// 简体中文语言包
// 注意：这是基础语言，所有的key都是简体中文，value也是简体中文
// 这样设计的目的是让开发时直接使用中文作为key，便于理解和维护

export default {
  // 算力申请页面 - Computing.vue
  computing: {
    // 页面标题和基础信息
    '平台资产': '可用余额',
    '质押金额': '理财本金',
    '技术模块': '农业理财',
    '理财说明': '日反产品每日把利息打到可用余额，本金锁定到期赎回；到期反产品周期内不计日息，到期或赎回时一次性结清全部利息。',
    '全部产品': '全部',
    '日反': '日反',
    '到期反': '到期反',
    '日预计': '预计日收益',
    '到期预计': '到期预计收益',
    '暂无该类型产品': '暂无该类型产品',
    '日利率': '日利率',
    '算力周期': '算力周期',
    '天': '天',
    '算力类型': '算力类型',
    '基础算力': '基础算力',
    '高级算力': '高级算力',
    '超级算力': '超级算力',
    '企业算力': '企业算力',
    '垂直种植系统': '垂直种植系统',
    '无土栽培': '无土栽培',
    'LED人工光': 'LED人工光',
    'AI环境控制': 'AI环境控制',
    '精准灌溉/营养液': '精准灌溉/营养液',
    '传感器+数据系统': '传感器+数据系统',
    '自动化生产': '自动化生产',
    '植物算法/育种': '植物算法/育种',
    '高性能': '高性能',
    '标准': '标准',
    '经济型': '经济型',
    '申请算力': '申请算力',
    '可申请次数': '可申请次数',
    '剩余次数': '剩余次数',
    '短算力类型': '类型',
    '短算力周期': '周期',
    '短预计日收益': '日收益',
    '短剩余次数': '剩余',
    '短解押记录': '赎回记录',
    '短算力记录': '认购记录',
    '短质押明细': '持仓明细',
    '短待审': '待审',
    '短成功': '成功',
    '短失败': '失败',
    '短完成': '完成',
    '超级算力申请': '加入方案',

    '步骤提示租赁': '步骤1 选择技术模块 · 步骤2 点击“加入方案”完成',
    '请选择算力方案': '请选择理财产品',
    '请先选择算力方案': '请先选择理财产品后再加入方案',    '算力收益等级': '算力收益等级',
    '查看算力收益等级': '查看算力收益等级',
    '暂无高级算力等级数据': '暂无高级算力等级数据',
    '暂无超级算力等级数据': '暂无超级算力等级数据',

    // 算力详情
    '算力详情': '算力详情',
    '基本信息': '基本信息',
    '原押金额': '原押金额',
    '暂无数据': '暂无数据',
    '算力类型标签': '算力类型：',
    '算力周期标签': '算力周期：',
    '预计收益': '预计收益：',
    '质押要求': '质押要求：',
    '开始时间': '开始时间：',
    '结束时间': '结束时间：',
    '立即申请': '立即申请',
    
    // 状态和提示
    '申请中': '申请中...',
    '申请成功': '申请成功',
    '申请失败': '申请失败',
    '申请失败，请重试': '申请失败，请重试',
    '余额不足': '余额不足',
    '请先连接钱包': '请先连接钱包',
    '算力申请成功': '算力申请成功！',
    '算力申请失败，请重试': '算力申请失败，请重试',
    '申请失败，请先解押已完成的算力订单': '申请失败，请先解押已完成的算力订单',
    'USDC': 'USDC',
    
    // 确认弹窗
    '确认申请': '确认申请',
    '取消': '取消',
    '确认': '确认',

    '您确定要申请此算力吗': '您确定要申请此算力吗？',
    '申请后将扣除相应的质押金额': '申请后将扣除相应的质押金额',
    
    // 算力状态
    '运行中': '运行中',
    '已完成': '已完成',
    '待开始': '待开始',
    '已取消': '已取消',
    
    // 收益相关
    '预计日收益': '预计日收益',
    '总预计收益': '总预计收益',
    '当前收益': '当前收益',
    
    // 记录和状态
    '解押申请记录': '赎回记录',
    '超级算力申请记录': '算力记录',
    '解压入口': '解押入口',
    '申请解押': '算力赎回',
    '暂无可解压的申请': '暂无可赎回的申请',
    '申请时间': '申请时间',
    '到期时间': '到期时间',
    '可解压': '可赎回',
    '确认解压': '确认赎回',
    '解压确认': '赎回确认',
    '解压成功': '赎回成功',
    '解压失败': '赎回失败',
    '资金已返回到您的账户': '资金已返回到您的账户',
    '网络错误，请重试': '网络错误，请重试',
    '全部': '全部',
    '待审核': '待审核',
    '成功': '成功',
    '失败': '失败',
    '正在加载记录': '正在加载记录...',
    '暂无记录': '暂无记录',
    '解押金额': '赎回金额',
    '申请天数': '申请天数',
    '金额': '金额',

    // 弹窗相关
    '选择周期': '选择周期',
    '收益率': '收益率',
    '申请金额': '申请金额',
    '请输入申请金额': '请输入申请金额',
    '最大可申请金额': '最大可申请金额',
    '投入限额': '投入限额',
    '最低投入': '最低投入',
    '最大投入': '最大投入',
    '短投入限额': '限额',
    '提交中': '提交中...',

    // 错误提示
    '网络错误，请稍后重试': '网络错误，请稍后重试',
    '参数错误': '参数错误',
    '服务器错误': '服务器错误',
    '未知错误': '未知错误',
    '质押金额不足': '质押金额不足',
    '解押金额不能超过当前质押金额': '赎回金额不能超过当前质押金额',
    '需要连接钱包才能申请算力': '需要连接钱包才能申请算力',
    '需要连接钱包才能申请解押': '需要连接钱包才能申请赎回',
    '请输入有效金额': '请输入有效金额',
    '请输入有效的申请金额': '请输入有效的申请金额',
    '申请金额不能低于最低投入': '申请金额不能低于最低投入',
    '申请金额不能高于最大投入': '申请金额不能高于最大投入',
    '请输入大于0的解押金额': '请输入大于0的赎回金额',
    '申请提交成功': '申请提交成功！',
    '您的解押申请已提交，请等待审核': '您的赎回申请已提交，请等待审核',
    '申请提交失败': '申请提交失败',
    '请稍后重试': '请稍后重试',
    '您的账户余额不足，无法申请算力': '您的账户余额不足，无法申请算力',
    '您的算力申请已提交，请等待审核': '您的算力申请已提交，请等待审核',
    '登录已过期': '登录已过期',
    '请重新连接钱包': '请重新连接钱包',
    '加载失败': '加载失败',
    '无法获取解押申请记录': '无法获取赎回申请记录',
    '您还有待审核的申请，请等待审核完成后再提交新申请': '您还有待审核的申请，请等待审核完成后再提交新申请',
    '您还有未解押的算力订单，无法申请新的算力': '您还有未赎回的算力订单，无法申请新的算力',
    '申请次数已用完，最大申请次数': '申请次数已用完，最大申请次数',
    '没有可解押的金额': '没有可赎回的金额',
    '您已有待处理的解押申请，请等待审核': '您已有待处理的赎回申请，请等待审核',

    '我的算力订单': '我的算力订单',
    '总质押': '总质押',
    '总收益': '总收益',
    '进行中': '进行中',
    '剩余天数': '剩余天数',
    '暂无算力订单': '暂无算力订单',

    // 钱包连接相关弹窗
    '钱包未连接': '钱包未连接',
    '钱包信息错误': '钱包信息错误',
    '钱包地址无效': '钱包地址无效',
    '授权已失效': '授权已失效',
    '授权检查失败': '授权检查失败',
    '请重新授权USDC后再进行投资': '请重新授权USDC后再进行投资',
    '请稍后重试或重新连接钱包': '请稍后重试或重新连接钱包',
    '断开连接': '断开连接',

    // 状态文本映射
    '状态待审核': '待审核',
    '状态成功': '成功',
    '状态失败': '失败',
    '状态进行中': '进行中',
    '状态已完成': '已完成',
    '状态已取消': '已取消',
    '状态未知': '未知',

    // 钱包地址相关
    '未连接钱包': '未连接钱包',
    '地址格式错误': '地址格式错误',

    // 客服功能
    '客服功能开发中，敬请期待': '客服功能开发中，敬请期待！',

    // 算力设置相关
    '设置错误': '设置错误',
    '未找到对应的算力设置': '未找到对应的算力设置',
    '无法获取算力设置': '无法获取算力设置',

    // 解押相关（新增）
    '解押审核中': '赎回审核中',
    '已解押': '已赎回',
    '确认解押': '确认赎回',
    '处理中': '处理中...',
    '解押申请已提交': '赎回申请已提交',
    '请等待审核处理': '请等待审核处理',
    '解押申请失败': '赎回申请失败',
    '当前状态不允许解押': '当前状态不允许赎回',
    '申请赎回': '申请赎回',
    '赎回金额': '赎回金额',
    '赎回审核中': '赎回审核中',
    '未到期不可赎回': '未到期不可赎回',
    '暂不可赎回': '暂不可赎回',
    '当前算力未到期': '当前算力未到期，到期后才可申请赎回',
    '已赎回': '已赎回',
    '确认赎回': '确认赎回',
    '赎回申请已提交': '赎回申请已提交',
    '可赎回': '可赎回',
    '已到期': '已到期',
    '未到期': '未到期',
    '暂无可赎回算力': '暂无可赎回算力',
    '赎回申请失败': '赎回申请失败',
    '当前状态不允许赎回': '当前状态不允许赎回',
    '需要连接钱包才能申请赎回': '需要连接钱包才能申请赎回',
    '请输入大于0的赎回金额': '请输入大于0的赎回金额',
    '您的赎回申请已提交，请等待审核': '您的赎回申请已提交，请等待审核',
    '无法获取赎回申请记录': '无法获取赎回申请记录',
    '您还有未赎回的算力订单，无法申请新的算力': '您还有未赎回的算力订单，无法申请新的算力',
    '没有可赎回的金额': '没有可赎回的金额',
    '您已有待处理的赎回申请，请等待审核': '您已有待处理的赎回申请，请等待审核',
    '申请失败，请先赎回已完成的算力订单': '申请失败，请先赎回已完成的算力订单',
    '赎回后资金将退回到平台资产中不再产生收益': '赎回后资金将退回到平台资产中，不再产生收益。',

    // 质押明细相关（新增）
    '质押明细': '算力明细',
    '后值': '后值',
    '管理员操作': '管理员操作',
    '暂无质押记录': '暂无算力记录',
    '正在加载质押记录': '正在加载算力记录...',
    '获取质押记录失败': '获取算力记录失败',
    '收益': '收益',
    '质押': '算力',
    '解押': '赎回',
    '充值': '充值',
    '提现': '提现',
    '奖励': '奖励',
    '推荐奖励': '推荐奖励',
    '系统调整': '系统调整',
    '算力收益': '算力收益',
    '机器人收益': '机器人收益',

    // 加载和错误信息（新增）
    '无法获取申请详情': '无法获取申请详情',
    '请检查网络连接后重试': '请检查网络连接后重试',
    '未找到可解押的算力申请': '未找到可解押的算力申请',

    // 状态相关（新增）

    // 详情页面相关（新增）
    '算力申请详情': '算力申请详情',
    '算力申请记录': '算力申请记录',
    '正在加载详情': '正在加载详情...',
    '申请周期': '申请周期',
    '每日收益记录': '每日收益记录',
    '累计收益': '累计收益',
    '暂无收益记录': '暂无收益记录',
    '加载失败请重试': '加载失败，请重试',
    '重新加载': '重新加载',
    '包含累计收益': '包含累计收益',
    '解押后资金将退回到平台资产中不再产生收益': '解押后资金将退回到平台资产中，不再产生收益。'
  },

  wealth: {
    '理财资产': '理财资产',
    '理财产品': '理财产品',
    '我的持仓': '我的持仓',
    '持仓标题': '持仓',
    '持仓详情': '持仓详情',
    '累计收益': '累计收益',
    '今日收益': '今日收益',
    '全部': '全部',
    '活期': '活期',
    '定期': '定期',
    '日反': '日反',
    '到期反': '到期反',
    '日利率': '日利率',
    '订单号': '订单号',
    '含加息': '含加息',
    '起投': '起投',
    '最高': '最高',
    '天': '天',
    '期限': '期限',
    '随时赎回': '随时赎回',
    '加载中': '加载中',
    '暂无产品': '暂无产品',
    '产品规则': '产品规则',
    '规则日反': '日反：利息每日发放到可用余额，本金锁在持仓中。',
    '规则到期反': '到期反：持有期内不计日息，到期一次性结息并还本。',
    '规则活期赎回': '活期可随时赎回本金，赎回当日不计息。',
    '规则可提前': '定期未到期可提前赎回，罚息',
    '规则不可提前': '定期未到期不可赎回，到期自动还本结息。',
    '申购金额': '申购金额',
    '预计日收益': '预计日收益',
    '到期总收益': '到期总收益',
    '可用余额': '可用余额',
    '立即申购': '立即申购',
    '申购中': '申购中...',
    '申购失败': '申购失败',
    '进行中': '进行中',
    '已结束': '已结束',
    '暂无持仓': '暂无持仓',
    '本金': '本金',
    '已获收益': '已获收益',
    '剩余天数': '剩余',
    '可赎回': '可赎回',
    '已到期': '已到期',
    '已赎回': '已赎回',
    '提前赎回': '提前赎回',
    '每24小时': '每 24 小时',
    '状态': '状态',
    '收益流水': '收益流水',
    '暂无收益': '暂无收益记录',
    '赎回预览': '赎回预览',
    '退回本金': '预计退回本金',
    '罚息': '罚息',
    '到期利息': '到期利息',
    '没收未结利息': '未结利息将没收',
    '立即赎回': '立即赎回',
    '赎回中': '赎回中...',
    '赎回失败': '赎回失败',
    '市场': '市场',
    '产品介绍': '产品介绍',
    '交易区': '申购',
    '行情': '行情',
    '年化参考': '年化参考',
    '付息': '付息',
    '赎回规则': '赎回规则',
    '产品代码': '产品',
    '全部买入': '全部',
    '市场说明': '按日利率计息。日反每日入账，到期反到期还本结息，部分产品可提前赎回。',
    'VIP等级': 'VIP',
    '限购次数': '限购',
    '剩余次数': '剩余 {n}/{max} 次',
    '限购详情': '已购 {used}/{max} 次，剩余 {remaining} 次',
    '等级未解锁': '需先买 {current}/{required} 个{tier}',
    '等级未开放': '等级未解锁',
    '已达限购': '已达购买上限',
    '使用加息卡': '使用加息卡（可选）',
    '已选加息卡': '已选 {n}/{max} 张',
    '暂无待用加息卡': '暂无待用加息卡，可前往农场兑换',
    '加息后日利率': '加息后日利率'
  },

  // ==================== 资产页面 - Assets.vue ====================
  assets: {
    // 总资产
    '总资产': '总资产',
    '理财持仓': '理财持仓',
    '理财资产': '理财资产',
    '今日理财收益': '今日收益',
    '我的余额(元)': '我的余额(元)',

    // 收入概览
    '总收入': '总收入',
    '今日收入': '今日收入',
    '今日收益': '今日收益',
    '昨日收益': '昨日收益',
    '体验金': '体验金',
    '空投奖励': '空投奖励',

    // 操作按钮
    '充值': '充值',
    '快速充值说明': '多币种充值',
    '提现': '提现',
    '闪兑': '闪兑',
    '我的资产': '我的资产',
    '邀请': '邀请',
    '白皮书': '白皮书',
    '幸运轮': '幸运轮',
    '站内信': '站内信',
    '信用分': '信用分',
    '快捷邀请': '邀请',
    '快捷白皮书': '白皮',
    '快捷幸运轮': '幸运',
    '快捷信用分': '信用',
    '选择充值币种': '选择充值币种',
    '自动到账': '自动到账',
    '人工审核': '人工审核',
    '充值说明短': 'EVM 币种可自动到账；其他币种需提交交易后由后台审核。',
    '手动充值': '手动充值',
    '可选协议': '可选协议',
    '选择协议': '选择协议',
    '闪兑标题': '闪兑',
    '收款地址': '收款地址',
    '提交审核': '提交审核',
    '交易哈希': '交易哈希',
    '凭证链接': '凭证链接（可选）',
    '金额': '金额',
    '上传转账凭证': '上传转账凭证',
    '点击上传图片': '点击上传转账截图',
    '支持JPGPNG': '支持 JPG / PNG，最大 5MB',
    '手动充值提示': '请先向收款地址转账，再上传截图并填写金额提交审核。',
    '扫码转账': '扫码转账',
    '请上传图片': '请上传图片文件',
    '图片过大': '图片不能超过 5MB',
    '上传成功': '上传成功',
    '上传失败': '上传失败',
    '提交中': '提交中…',
    '已复制': '已复制',
    '复制成功': '复制成功',
    '提交成功等待审核': '已提交，请等待审核',
    '提交失败': '提交失败',
    '用户ID': '用户ID',
    '兑出': '兑出',
    '兑入': '兑入',
    '确认闪兑': '确认闪兑',
    '闪兑记录': '闪兑记录',
    '暂无闪兑记录': '暂无闪兑记录',
    '不可与兑出兑入相同币种': '不可与兑出/兑入相同币种',
    '兑出与兑入不能是相同币种': '兑出与兑入不能是相同币种',
    '报价失败': '报价失败',
    '金额无效': '金额无效',
    '兑入数量过小': '兑入数量过小',
    '闪兑失败': '闪兑失败',
    '闪兑成功': '闪兑成功',
    '复制地址': '复制',
    '暂无币种': '暂无可用币种',

    // VIP等级
    'VIP等级': 'VIP等级',
    '暂无VIP等级数据': '暂无VIP等级数据',

    // 我的账户
    '我的账户': '我的账户',
    '申请备用金': '申请备用金',
    '身份认证': '身份认证',
    '设置资金密码': '设置资金密码',
    '选择语言': '选择语言',
    '英语': 'English',

    // 控制台日志信息
    '钱包未连接，触发钱包连接': '钱包未连接，触发钱包连接',
    '钱包地址无效，重新连接': '钱包地址无效，重新连接',
    '钱包已连接，直接跳转到充值页面': '钱包已连接，直接跳转到充值页面',
    '检查授权状态失败': '检查授权状态失败',
    '白皮书功能': '白皮书功能',
    '检查资金密码状态失败': '检查资金密码状态失败',

    // API相关日志
    'Token不存在，显示默认余额': 'Token不存在，显示默认余额',
    '调用API获取用户余额数据': '调用API获取用户余额数据...',
    '体验金加载成功': '体验金加载成功',
    '总资产计算完成': '总资产计算完成',
    '余额': '余额',
    '质押金额': '算力金额',
    'API返回失败': 'API返回失败',
    '加载用户余额失败': '加载用户余额失败',
    'Token不存在，显示默认收益': 'Token不存在，显示默认收益',
    '调用API获取用户收益数据': '调用API获取用户收益数据...',
    '收益数据加载成功': '收益数据加载成功',
    '收益API返回失败': '收益API返回失败',
    '加载用户收益失败': '加载用户收益失败',
    '使用默认收益数据': '使用默认收益数据',
    '信用分加载成功': '信用分加载成功',

    // 语言选择
    '中文（简体）': '中文（简体）',

    // 空投奖励相关
    '钱包地址': '钱包地址',
    '调用API获取空投奖励数据': '🔍 调用API获取空投奖励数据...',

    // 客服相关
    '打开客服': '打开客服',
    '客服功能开发中，敬请期待': '客服功能开发中，敬请期待！',

    // 页面加载
    '资产页面已加载': '资产页面已加载'
  },

  // ==================== 充值页面 - Recharge.vue ====================
  recharge: {
    // 页面标题和导航
    '充值': '充值',
    '返回': '返回',
    '充值记录': '充值记录',

    // 步骤标题
    '选择金额': '选择金额',
    '确认订单': '确认订单',
    '完成转账': '完成转账',

    // 金额输入
    '请输入充值金额': '请输入充值金额',
    '自定义': '自定义',
    '最小充值金额': '最小充值金额',
    '最低': '最低',
    '余额不足': '余额不足',
    '最小充值金额提示': '最低 500 USDC',
    '最大充值金额': '最大充值金额',
    '下一步': '下一步',
    '上一步': '上一步',
    '开通自动转入': '开通自动转入',

    // 订单信息
    '订单信息': '订单信息',
    '订单号': '订单号',
    '充值金额': '充值金额',
    '网络': '网络',
    '代币': '代币',
    '收款地址': '收款地址',
    '创建订单': '创建订单',
    '创建中': '创建中...',

    // 钱包连接相关
    '请先连接钱包': '请先连接钱包',
    '未检测到钱包地址，请先连接钱包': '未检测到钱包地址，请先连接钱包',

    // 余额相关
    'USDC余额不足': 'USDC余额不足！当前余额',
    '转账超时，请检查钱包或重试': '转账超时，请检查钱包或重试',
    '转账成功但没有获得交易哈希，请手动提供交易哈希': '转账成功但没有获得交易哈希，请手动提供交易哈希',
    '请先连接MetaMask钱包': '请先连接MetaMask钱包',
    '转账可能成功但无法获取交易哈希，请手动检查钱包': '转账可能成功但无法获取交易哈希，请手动检查钱包',
    '交易哈希无效，请稍后在钱包历史中复制正确的交易哈希': '交易哈希无效，请稍后在钱包历史中复制正确的交易哈希',
    '钱包地址不存在': '钱包地址不存在',
    '交易失败': '交易失败',
    '当前网络': '当前网络',
    '请切换到以太坊主网或测试网': '请切换到以太坊主网或测试网',
    '未知网络': '未知网络 (Chain ID: {id})',
    '检测到Cronos网络': '检测到 Cronos 网络 (Chain ID: 25)。请在钱包中切换到以太坊主网，然后刷新页面重试。',
    '请点击页面右上角网络设置，选择Ethereum，然后重新充值。': '请点击页面右上角网络设置，选择Ethereum，然后重新充值。',
    '需要': '需要',
    '更新订单失败': '更新订单失败',

    // 转账步骤
    '请使用钱包转账': '请使用钱包转账',
    '转账地址': '转账地址',
    '转账金额': '转账金额',
    '合约地址': '合约地址',
    '复制地址': '复制地址',
    '复制金额': '复制金额',
    '开始转账': '开始转账',
    '重新转账': '重新转账',
    '查看详情': '查看详情',

    // 状态信息
    '等待转账': '等待转账',
    '确认中': '确认中',
    '转账成功': '转账成功',
    '转账失败': '转账失败',
    '交易哈希': '交易哈希',
    '在区块链浏览器中查看': '在区块链浏览器中查看',

    // 提示信息
    '请确保转账金额准确': '请确保转账金额准确',
    '请确保使用正确的网络': '请确保使用正确的网络',
    '转账完成后系统会自动确认': '转账完成后系统会自动确认',
    '地址已复制': '地址已复制',
    '金额已复制': '金额已复制',
    '复制失败': '复制失败',

    // 错误信息
    '金额不能为空': '金额不能为空',
    '金额必须大于': '金额必须大于',
    '金额不能超过': '金额不能超过',
    '创建订单失败': '创建订单失败',
    '转账失败，请重试': '转账失败，请重试',
    '网络错误，请检查连接': '网络错误，请检查连接',

    // MetaMask相关
    '网络检查通过': '网络检查通过',
    'USDC余额不足！当前余额': 'USDC余额不足！当前余额: {balance} USDC，需要: {amount} USDC',
    '余额检查通过': '✅ 余额检查通过',
    '余额检查失败': '余额检查失败',
    '开始执行转账': '🚀 开始执行转账...',
    '请在MetaMask中确认交易': '⏳ 请在MetaMask中确认交易',
    '最终交易哈希': '✅ 最终交易哈希',
    '交易哈希已保存到数据库': '✅ 交易哈希已保存到数据库',
    '保存哈希失败': '❌ 保存哈希失败',
    '转账发送失败': '❌ 转账发送失败',
    '交易哈希更新成功': '✅ 交易哈希更新成功',
    '更新订单交易哈希失败': '❌ 更新订单交易哈希失败',
    '启动交易监控，订单号': '🔄 启动交易监控，订单号',
    '检查交易状态': '🔍 检查交易状态...',
    '订单状态响应': '📊 订单状态响应',
    '订单详情': '📋 订单详情',
    '交易成功': '✅ 交易成功！',
    '交易还在确认中，状态': '⏳ 交易还在确认中，状态',
    'API响应失败': '❌ API响应失败',
    '检查交易状态失败': '检查交易状态失败',
    '转账状态已重置': '🔄 转账状态已重置',

    // 客服相关
    '客服功能开发中，敬请期待': '客服功能开发中，敬请期待！',

    // 算力收益等级相关
    '查看算力收益等级': '查看算力收益等级',
    '算力收益等级': '算力收益等级',
    '暂无算力收益等级数据': '暂无算力收益等级数据',
    '获取算力收益等级失败': '获取算力收益等级失败',
    '日收益率': '日收益率'
  },

  // ==================== 充值记录页面 - RechargeHistory.vue ====================
  rechargeHistory: {
    '充值记录': '充值记录',
    '全部': '全部',
    '待支付': '待支付',
    '待审核': '待审核',
    '确认中': '确认中',
    '成功': '成功',
    '失败': '失败',
    '已完成': '已完成',
    '已取消': '已取消',
    '暂无记录': '暂无记录',
    '加载中': '加载中...',
    '加载更多': '加载更多',
    '没有更多数据': '没有更多数据',
    '暂无充值记录': '暂无充值记录',
    '立即充值': '立即充值',
    '充值': '充值',
    '订单号': '订单号',
    '筛选': '筛选',
    '记录': '记录',
    '总充值': '总充值',
    '刚刚': '刚刚',
    '分钟前': '分钟前',
    '小时前': '小时前'
  },

  // ==================== 充值详情页面 - RechargeDetail.vue ====================
  rechargeDetail: {
    '充值详情': '充值详情',
    '加载中': '加载中',
    '订单不存在或已删除': '订单不存在或已删除',
    '返回': '返回',
    '订单信息': '订单信息',
    '订单号': '订单号',
    '充值网络': '充值网络',
    '订单状态': '订单状态',
    '创建时间': '创建时间',
    '支付时间': '支付时间',
    '确认时间': '确认时间',
    '完成时间': '完成时间',
    '转账信息': '转账信息',
    '充值地址': '充值地址',
    '复制': '复制',
    '交易哈希': '交易哈希',
    '确认进度': '确认进度',
    '确认': '确认',
    '查看区块浏览器': '查看区块浏览器',
    '取消订单': '取消订单',
    '交易信息': '交易信息',
    '区块确认数': '区块确认数',
    '手续费': '手续费',
    '备注': '备注'
  },

  // ==================== 提现页面 - Withdrawal.vue ====================
  withdrawal: {
    // 页面标题和导航
    '提现': '提现',
    '返回': '返回',
    '提现记录': '提现记录',

    // 余额显示
    '我的提现账户余额': '我的提现账户余额',
    '可提现余额': '可提现余额',
    '当前可提取余额': '当前可提取余额',
    '信用分': '信用分',

    // 表单字段
    '提现金额': '提现金额',
    '请输入提现金额': '请输入提现金额',
    '请输入自定义提款金额': '请输入自定义提款金额',
    '最大限度': '最大限度',
    '提现地址': '提现地址',
    '请输入提现地址': '请输入提现地址',
    '请输入正确的提现地址': '请输入正确的提现地址',
    '提现密码': '提现密码',
    '请输入提现密码': '请输入提现密码',
    '资金密码': '资金密码',
    '请输入资金密码': '请输入资金密码',
    '显示密码': '显示密码',
    '隐藏密码': '隐藏密码',

    // 提现规则
    '提款规则': '提款规则',
    '提现规则': '提现规则',
    '手续费': '手续费',
    '单笔范围': '单笔范围',
    '提现手续费': '提现手续费',
    '提现金额范围': '提现金额范围',
    '资金将在1-24小时内到账': '资金将在1-24小时内到账',
    '手续费率': '手续费率',
    '最小提现金额': '最小提现金额',
    '最大提现金额': '最大提现金额',
    '预计到账时间': '预计到账时间',
    '工作日内处理': '工作日内处理',

    // 按钮和操作
    '确认提款': '确认提款',
    '处理中': '处理中',
    '提交申请': '提交申请',
    '提交中': '提交中...',
    '设置资金密码': '设置资金密码',
    '忘记密码': '忘记密码？',
    '取消': '取消',
    '去设置': '去设置',

    // 弹窗提示
    '需要设置资金密码': '需要设置资金密码',
    '为了您的资金安全，请先设置资金密码': '为了您的资金安全，请先设置资金密码',

    // 成功提示
    '申请提交成功': '申请提交成功',
    '您的提现申请已提交，请等待审核': '您的提现申请已提交，请等待审核',
    '提现申请已提交': '提现申请已提交',
    '请等待审核': '请等待审核',

    // 错误提示
    '申请提交失败': '申请提交失败',
    '提现申请失败': '提现申请失败',
    '请稍后重试': '请稍后重试',
    '余额不足': '余额不足',
    '金额格式错误': '金额格式错误',
    '地址格式错误': '地址格式错误',
    '资金密码错误': '资金密码错误',
    '您还有待处理的提现申请，请等待处理完成后再提交新申请': '您还有待处理的提现申请，请等待处理完成后再提交新申请',
    '信用分不足': '信用分不足',
    '信用分不足无法提款': '信用分不足，无法提款',
    '需要KYC认证': '需要 KYC 认证',
    '请先完成KYC认证后才能提现': '请先完成 KYC 认证后才能提现',
    'KYC等级': 'KYC 等级',
    '今日剩余额度': '今日剩余额度',
    '您有待还款订单，请还款后申请提现': '您有待还款订单，请还款后申请提现！',

    // 系统消息和日志
    '用户提现申请': '用户提现申请',
    '加载用户数据失败': '加载用户数据失败',
    '检查资金密码状态失败': '检查资金密码状态失败'
  },



  // ==================== 幸运轮页面 - LuckyWheel.vue ====================
  luckyWheel: {
    // 页面标题
    '幸运轮': '幸运轮',
    '页面副标题': '九宫格抽奖 · 跑马灯开奖',

    // 抽奖信息
    '剩余': '剩余',
    '次': '次',
    '奖金': '奖金',
    '抽奖': '抽奖',
    '奖品': '奖品',
    '暂无中奖记录': '暂无中奖记录',
    '总抽奖次数': '总抽奖次数',
    '抽奖次数不足': '抽奖次数不足',
    '提示': '提示',
    '抽奖失败': '抽奖失败',
    '网络错误': '网络错误',
    '网络错误，请重试': '网络错误，请重试',

    // 历史记录
    '中奖时间': '中奖时间',
    '中奖金额': '中奖金额',
    '状态': '状态',
    '暂无数据': '暂无数据',

    // 状态文本
    '待发放': '待发放',
    '已发放': '已发放',
    '发放失败': '发放失败',

    // 中奖弹窗
    '恭喜中奖': '恭喜中奖！',
    '确定': '确定'
  },

  // ==================== 申请备用金页面 - ApplyFunds.vue ====================
  applyFunds: {
    // 页面标题
    '申请备用金': '申请备用金',

    // 步骤1
    '经平台审核，您可向平台申请一笔借款': '经平台审核，您可向平台申请一笔借款',
    '借贷产品': '借贷产品',
    '请选择产品': '请选择产品',
    '借款金额': '借款金额',
    '输入借款金额': '输入借款金额',
    '还款周期': '还款周期',
    '请输入还款周期': '请输入还款周期',
    '天': '天',
    '日利率': '日利率',
    '利息': '利息',
    '还款方式': '还款方式',
    '免款服务由AI Agents提供，请通过外部资金偿还': '免款服务由HamiltonLane提供，请通过外部资金偿还',
    '放款机构': '放款机构',
    '借款规则': '借款规则',
    '下一步': '下一步',

    // 步骤2
    '姓名': '姓名',
    '手机号': '手机号',
    '证件上传': '证件上传',
    '身份证正面': '身份证正面',
    '身份证反面': '身份证反面',
    '点击上传': '点击上传',
    '重新上传': '重新上传',
    '上传成功': '上传成功',
    '上传失败': '上传失败',
    '请上传身份证正面': '请上传身份证正面',
    '请上传身份证反面': '请上传身份证反面',
    '请输入': '请输入',
    '提交中': '提交中...',
    '确定': '确定',
    '请选择图片文件': '请选择图片文件',
    '文件大小不能超过10MB': '文件大小不能超过10MB',

    // 步骤3
    '恭喜您申请成功': '恭喜您申请成功',
    '您的借款已申请成功，待平台审核成功放款': '您的借款已申请成功，待平台审核成功放款',

    // 产品选择弹窗
    '选择借贷产品': '选择借贷产品',

    // 错误消息
    '申请失败': '申请失败',
    '申请失败，请重试': '申请失败，请重试',

    // 产品名称翻译
    '产品名称': {
      '快速借贷': '快速借贷',
      '标准借贷': '标准借贷',
      '长期借贷': '长期借贷',
      '小额借贷': '小额借贷',
      '大额借贷': '大额借贷',
      '短期借贷产品': '短期借贷产品'
    },

    // 产品描述翻译
    '产品描述': {
      '适合短期资金周转的借贷产品，利率优惠，审核快速': '适合短期资金周转的借贷产品，利率优惠，审核快速'
    },

    // API消息翻译
    'API消息': {
      '获取借贷产品成功': '获取借贷产品成功'
    }
  },

  // ==================== 借款记录页面 - LoanRecords.vue ====================
  loanRecords: {
    // 页面标题
    '借款记录': '借款记录',
    '借贷中心': '借贷中心',
    '总记录': '总记录',
    '总借款': '总借款',
    '进行中': '进行中',

    // 选项卡
    '全部': '全部',

    // 加载和空状态
    '加载中': '加载中',
    '没有更多数据了': '没有更多数据了',

    // 记录信息
    '借款': '借款',
    '借款金额': '借款金额',
    '还款周期': '还款周期',
    '天': '天',
    '日利率': '日利率',
    '利息': '利息',
    '还款方式': '还款方式',
    '免款服务由AI Agents提供，请通过外部资金偿还': '免款服务由HamiltonLane提供，请通过外部资金偿还',
    '放款机构': '放款机构',

    // 状态
    '待审核': '待审核',
    '已通过': '已通过',
    '审核成功': '审核成功',
    '已驳回': '已驳回',
    '审核失败': '审核失败',
    '已还款': '已还款',
    '逾期': '逾期',
    '未知状态': '未知状态'
  },

  // ==================== 机器人投资页面 - RobotInvestment.vue ====================
  robotInvestment: {
    // 页面标题
    '详情': '详情',
    '返回': '返回',

    // 申购信息
    '申购金额': '申购金额',
    '购买金额': '购买金额',
    '最大': '最大',
    '最小限额': '最小限额',
    '最大限额': '最大限额',
    '日收益率': '日收益率',
    '周期': '周期',
    '天': '天',

    // 余额信息
    '可用余额': '可用余额',
    '可购次数': '可购次数',

    // 按钮和状态
    '处理中': '处理中',
    '申购': '申购',
    '余额错误': '余额错误',
    '无法获取有效的余额信息': '无法获取有效的余额信息',
    '输入错误': '输入错误',
    '请输入申购金额': '请输入申购金额',
    '请输入有效的申购金额': '请输入有效的申购金额',
    '钱包未连接': '钱包未连接',
    '请先连接钱包': '请先连接钱包',
    '钱包信息错误': '钱包信息错误',
    '请重新连接钱包': '请重新连接钱包',
    '钱包地址无效': '钱包地址无效',
    '授权已失效': '授权已失效',
    '请重新授权USDC后再进行投资': '请重新授权USDC后再进行投资',
    '授权检查失败': '授权检查失败',
    '请稍后重试或重新连接钱包': '请稍后重试或重新连接钱包',
    '金额不足': '金额不足',
    '申购金额不能少于': '申购金额不能少于',
    '金额超限': '金额超限',
    '申购金额不能超过': '申购金额不能超过',
    '余额不足': '余额不足',
    '您的可用余额为': '您的可用余额为',
    '无法完成此次申购': '无法完成此次申购',
    '申购成功': '申购成功',
    '订单号': '订单号',
    '申购失败': '申购失败',
    '申购失败，请稍后重试': '申购失败，请稍后重试',
    '网络错误，请稍后重试': '网络错误，请稍后重试'
  },

  // ==================== KYC 身份认证 - Kyc.vue ====================
  kyc: {
    '身份认证': '身份认证',
    '加载中': '加载中...',
    '未认证': '未认证',
    '已通过Lv1': '已通过 Lv1',
    '已通过Lv2': '已通过 Lv2',
    '完成认证后才可提现': '完成认证后才可提现',
    '可继续升级Lv2提高额度': '可继续升级 Lv2 提高提现额度',
    '可享受最高提现额度': '可享受最高提现额度',
    '单笔限额': '单笔限额',
    '今日剩余': '今日剩余',
    '审核中': '审核中',
    '请耐心等待审核结果': '请耐心等待审核结果',
    '已驳回': '已驳回',
    '请修改后重新提交': '请修改后重新提交',
    'Lv1基础认证': 'Lv1 基础认证',
    'Lv2高级认证': 'Lv2 高级认证',
    '真实姓名': '真实姓名',
    '请输入真实姓名': '请输入真实姓名',
    '邮箱': '邮箱',
    '请输入邮箱': '请输入邮箱',
    '证件号码': '证件号码',
    '请输入证件号码': '请输入证件号码',
    '国家地区': '国家/地区',
    '请输入国家或地区': '请输入国家或地区',
    '证件正面': '证件正面',
    '证件反面': '证件反面',
    '提交Lv1认证': '提交 Lv1 认证',
    '提交Lv2认证': '提交 Lv2 认证',
    '提交中': '提交中...',
    '请录制本人与证件同框视频': '请录制本人手持证件的同框视频',
    '上传同框视频': '上传同框视频',
    '您已完成全部认证': '您已完成全部认证',
    '上传失败': '上传失败',
    '提交成功': '提交成功',
    '提交失败': '提交失败',
    '已完成': '已完成',
    '基础认证': '基础认证',
    '高级认证': '高级认证'
  },

  // ==================== 设置资金密码页面 - SetFundPassword.vue ====================
  setFundPassword: {
    // 页面标题
    '设置资金密码': '设置资金密码',
    '安全中心': '安全中心',

    // 密码提示
    '密码长度至少6位': '密码长度至少6位',
    '密码长度不超过20位': '密码长度不超过20位',

    // 确认密码
    '确认密码': '确认密码',
    '两次输入的密码一致': '两次输入的密码一致',

    // 按钮
    '设置中': '设置中...',
    '确定': '确定',

    // API响应消息
    '参数验证失败': '参数验证失败',
    '您已设置过资金密码，如需修改请联系客服': '您已设置过资金密码，如需修改请联系客服',
    '资金密码设置成功': '资金密码设置成功',
    '设置失败': '设置失败',
    '获取状态失败': '获取状态失败',

    // 前端提示消息
    '设置成功': '设置成功',
    '请稍后重试': '请稍后重试',
    '设置资金密码失败': '设置资金密码失败'
  },

  // ==================== 修改资金密码页面 - ModifyFundPassword.vue ====================
  modifyFundPassword: {
    // 页面标题
    '修改资金密码': '修改资金密码',
    '修改安全密码': '修改安全密码',
    '返回': '返回',

    // 状态显示
    '已设置资金密码': '已设置资金密码',

    // 表单字段
    '原密码': '原密码',
    '请输入原密码': '请输入原密码',
    '新密码': '新密码',
    '请输入新密码': '请输入新密码',
    '确认新密码': '确认新密码',
    '请再次输入新密码': '请再次输入新密码',

    // 按钮和操作
    '确认修改': '确认修改',
    '修改中': '修改中...',
    '忘记原密码': '忘记原密码？',
    '忘记安全密码': '忘记安全密码?',
    '联系客服': '联系客服',
    '取消': '取消',

    // 提示信息
    '原密码不能为空': '原密码不能为空',
    '原密码错误': '原密码错误',
    '新密码不能与原密码相同': '新密码不能与原密码相同',
    '密码修改成功': '密码修改成功',
    '密码修改失败': '密码修改失败',
    '如需重置安全密码，请联系客服人员协助处理': '如需重置安全密码，请联系客服人员协助处理',

    // API响应消息
    '参数验证失败': '参数验证失败',
    '您尚未设置资金密码': '您尚未设置资金密码',
    '资金密码修改成功': '资金密码修改成功',
    '修改失败': '修改失败',

    // 前端提示消息
    '修改安全密码失败': '修改安全密码失败',
    '请稍后重试': '请稍后重试',

    // 密码验证提示
    '密码长度6-20位': '密码长度6-20位',
    '两次输入的密码一致': '两次输入的密码一致'
  },

  // ==================== 空投奖励页面 - AirdropRewards.vue ====================
  airdropRewards: {
    // 页面标题
    '空投奖励': '空投奖励',
    '返回': '返回',

    // 统计信息
    '累计获得 (USDC)': '累计获得 (USDC)',
    '待发放数量': '待发放数量',
    '待发放金额 (USDC)': '待发放金额 (USDC)',

    // 筛选标签
    '全部': '全部',
    '待发放': '待发放',
    '已发放': '已发放',

    // 状态文本
    '已取消': '已取消',
    '发放失败': '发放失败',
    '失败': '失败',
    '未知': '未知',

    // 时间相关
    '发放时间': '发放时间',

    // 加载状态
    '加载更多': '加载更多...',
    '没有更多数据了': '没有更多数据了',
    '暂无空投奖励记录': '暂无空投奖励记录',

    // 奖励信息
    '总奖励': '总奖励',
    '今日奖励': '今日奖励',
    '待领取': '待领取',
    '已领取': '已领取',

    // 奖励列表
    '奖励记录': '奖励记录',
    '奖励类型': '奖励类型',
    '奖励金额': '奖励金额',
    '获得时间': '获得时间',
    '领取状态': '领取状态',
    '领取': '领取',

    // 奖励类型
    '注册奖励': '注册奖励',
    '邀请奖励': '邀请奖励',
    '活动奖励': '活动奖励',
    '签到奖励': '签到奖励',
    '推广奖励': '推广奖励',

    // 操作提示
    '领取成功': '领取成功',
    '领取失败': '领取失败',
    '暂无奖励记录': '暂无奖励记录',
    '全部领取': '全部领取'
  },

  // ==================== 邀请弹窗 - InviteModal.vue ====================
  invite: {
    // 弹窗标题和内容
    '邀请好友一起赚币': '邀请好友一起赚币',
    '复制邀请码': '复制邀请码',
    '朋友扫二维码注册加入': '朋友扫二维码注册加入',
    '邀请链接': '邀请链接',

    // 错误消息
    '加载邀请数据失败': '加载邀请数据失败',
    '加载失败': '加载失败',
    '获取邀请信息失败，请稍后重试': '获取邀请信息失败，请稍后重试',
    '生成二维码失败': '生成二维码失败',

    // 复制功能
    '邀请码已复制': '邀请码已复制',
    '邀请链接已复制': '邀请链接已复制',
    '复制失败': '复制失败',
    '请手动复制': '请手动复制'
  },

  // ==================== 顶部导航 - TopHeader.vue ====================
  topHeader: {
    '选择网络': '选择网络',
    'ERC20-USDC': 'ERC20-USDC',
    'ERC20-USDT': 'ERC20-USDT',
    '登录进行中': '登录进行中',
    '连接钱包': '连接钱包',
    '连接中': '连接中...',
    '已连接': '已连接',
    '连接成功': '连接成功！',
    '钱包已成功连接': '钱包已成功连接',
    '钱包信息': '钱包信息',
    '钱包地址': '钱包地址',
    '断开连接': '断开连接',
    '已断开连接': '已断开连接',
    '正在初始化': '正在初始化...',
    '正在切换网络': '正在切换网络...',
    '登录完成': '登录完成',
    '请在钱包中确认': '请在钱包中确认...',
    '登录成功': '登录成功',

    // 钱包连接错误信息
    '钱包连接失败': '钱包连接失败',
    '未知错误': '未知错误',
    '认证失败，请重试连接钱包': '认证失败，请重试连接钱包',
    '钱包连接请求正在处理中，请稍等或刷新页面后重试': '钱包连接请求正在处理中，请稍等或刷新页面后重试',
    '钱包连接请求正在等待处理，请在钱包中确认': '钱包连接请求正在等待处理，请在钱包中确认',
    '授权失败': '授权失败',
    '交易被撤销，可能是合约错误或余额不足': '交易被撤销，可能是合约错误或余额不足',

    // 钱包连接状态提示
    '欢迎！您的账户已创建成功': '欢迎！您的账户已创建成功',
    '钱包连接成功': '钱包连接成功',
    '钱包已断开连接': '钱包已断开连接',
    '是否断开钱包连接？': '是否断开钱包连接？',

    '确定': '确定',

    // 新增的翻译键 - TopHeader.vue 中的中文文本
    '钱包未连接，请先连接钱包': '钱包未连接，请先连接钱包',
    '中文（简体）': '中文（简体）',
    '用户取消了授权': '用户取消了授权',
    'ETH余额不足，无法支付Gas费用': 'ETH余额不足，无法支付Gas费用',
    'Gas费用设置过低': 'Gas费用设置过低',
    '交易nonce错误，请重试': '交易nonce错误，请重试',
    'Gas价格过低，请提高Gas价格': 'Gas价格过低，请提高Gas价格',
    '合约参数错误，请检查网络和合约地址': '合约参数错误，请检查网络和合约地址',
    '余额不足，无法完成授权': '余额不足，无法完成授权',
    '请安装 MetaMask 或其他以太坊钱包': '请安装 MetaMask 或其他以太坊钱包',
    '未检测到钱包': '未检测到钱包',
    '请使用钱包内置浏览器打开本站，或先安装 MetaMask / TokenPocket 后再登录。': '请使用钱包内置浏览器打开本站，或先安装 MetaMask / TokenPocket 后再登录。',
    '安装 MetaMask': '安装 MetaMask',
    '我知道了': '我知道了',
    '请安装 TronLink 钱包': '请安装 TronLink 钱包',
    '未找到授权目标地址，请先获取系统配置': '未找到授权目标地址，请先获取系统配置',
    '获取授权地址失败': '获取授权地址失败',
    '不支持的网络类型': '不支持的网络类型',
    '网络切换可能未完成，当前链ID': '网络切换可能未完成，当前链ID',
    '请刷新页面重试': '请刷新页面重试',
    '网络连接失败': '网络连接失败',
    '授权地址格式错误': '授权地址格式错误',
    '合约地址格式错误': '合约地址格式错误',
    'ETH余额不足！当前余额': 'ETH余额不足！当前余额',
    '需要': '需要',
    '钱包连接请求正在等待处理，请在MetaMask中确认': '钱包连接请求正在等待处理，请在MetaMask中确认',
    '钱包连接请求正在等待处理，请在Trust Wallet中确认': '钱包连接请求正在等待处理，请在Trust Wallet中确认',
    '钱包连接请求正在等待处理，请在Coinbase Wallet中确认': '钱包连接请求正在等待处理，请在Coinbase Wallet中确认'
  },

  // ==================== 钱包信息 - WalletInfo.vue ====================
  walletInfo: {
    '钱包地址已复制到剪贴板': '钱包地址已复制到剪贴板',
    '钱包信息已刷新': '钱包信息已刷新',
    '钱包信息已刷新（自动重连成功）': '钱包信息已刷新（自动重连成功）',
    '登录已过期，请重新连接钱包': '登录已过期，请重新连接钱包',
    '刷新失败': '刷新失败',
    '交易历史功能开发中': '交易历史功能开发中',
    '确定要断开钱包连接吗': '确定要断开钱包连接吗',
    '钱包已断开连接': '钱包已断开连接',
    '断开连接失败': '断开连接失败',
    '确定要测试归集功能吗？这将检查您的钱包是否可以进行归集操作': '确定要测试归集功能吗？这将检查您的钱包是否可以进行归集操作',
    '归集测试完成': '归集测试完成',
    '归集测试失败': '归集测试失败',
    '确定要归集ETH吗？这将把您钱包中的ETH转移到归集地址': '确定要归集ETH吗？这将把您钱包中的ETH转移到归集地址',
    'ETH归集成功': 'ETH归集成功',
    'ETH归集失败': 'ETH归集失败'
  },

  // ==================== 白皮书页面 - Whitepaper.vue ====================
  whitepaper: {
    '白皮书': '白皮书',
    '正在加载白皮书': '正在加载白皮书',
    '加载失败': '加载失败',
    '重试': '重试',
    '在新窗口打开': '在新窗口打开',
    '下载PDF': '下载PDF'
  },

  // ==================== 闪期权页面 - FlashOptions.vue ====================
  flashOptions: {
    '闪电期权': '闪期权',
    '请先连接钱包': '请先连接钱包',
    '连接钱包后即可开始闪电期权交易': '连接钱包后即可开始闪电期权交易',
    '连接钱包': '连接钱包',
    '加载中': '加载中...',
    '暂无可交易资产': '暂无可交易资产',
    '请稍后再试': '请稍后再试',
    '时间': '时间',
    '金额': '金额',
    '回报额': '回报额',
    '利润': '利润',
    '当前持仓': '当前持仓',
    '暂无持仓': '暂无持仓',
    '买涨': '▲ 买涨',
    '买跌': '▼ 买跌',
    '开仓': '开仓',
    '入场价': '入场价',
    '出场价': '出场价',
    '收益率': '收益率',
    '投入': '投入',
    '入场时间': '入场时间',
    '出场时间': '出场时间',
    '交易时长': '交易时长',
    '实时价': '实时价',
    '倒计时': '倒计时',
    '交易记录': '交易记录',
    '暂无记录': '暂无记录',
    '生成海报': '生成海报',
    '交易海报': '交易海报',
    '保存图片': '保存图片',
    '分享': '分享',
    '生成海报失败': '生成海报失败',
    '海报已保存': '海报已保存',
    '闪期权交易海报': '闪期权交易',
    '仅供展示不构成投资建议': '仅供展示，不构成投资建议',
    '智能交易': '智能交易',
    '交易标的': '交易标的',
    '风险类型': '风险类型',
    '投入金额': '投入金额',
    '提交申请': '提交申请',
    '我的AI订单': '我的AI订单',
    '稳健型': '稳健型',
    '平衡型': '平衡型',
    '进取型': '进取型',
    '稳健': '稳健',
    '平衡': '平衡',
    '进取': '进取',
    '低风险低回报适合稳健投资者': '低风险低回报，适合稳健投资者',
    '中等风险中等回报适合大多数投资者': '中等风险中等回报，适合大多数投资者',
    '高风险高回报适合激进投资者': '高风险高回报，适合激进投资者',
    '待审核': '待审核',
    '运行中': '运行中',
    '已停止': '已停止',
    '已结算': '已结算',
    '已驳回': '已驳回',
    'AI剩余': '剩余',
    'AI做单': '做单',
    'AI笔': '笔',
    'AI胜': '胜',
    'AI负': '负',
    '请先选择交易标的': '请先选择交易标的',
    '请输入有效金额': '请输入有效金额',
    'AI交易申请已提交': 'AI交易申请已提交，等待审核',
    'AI提交失败': '提交失败',
    '取消申请': '取消申请',
    '停止交易': '停止交易',
    '确认停止AI交易': '确认停止AI交易？剩余资金将退回余额',
    '停止失败': '停止失败',
    '确认取消AI申请': '确认取消该AI交易申请？冻结金额将退回余额',
    '取消失败': '取消失败',
    '涨': '涨',
    '跌': '跌',
    '秒': '秒',
    '分钟': '分钟',
    '结算中': '结算中...',
    '加载配置失败': '加载配置失败',
    '请完善交易信息': '请完善交易信息',
    '下单失败': '下单失败',
    '买涨成功': '买涨成功',
    '买跌成功': '买跌成功',
    '等待行情数据': '等待行情数据...',
    '余额不足': '余额不足',
    '资产不可用': '资产不可用',
    '周期不可用': '周期不可用',
    '实盘交易': '实盘交易',
    '模拟交易': '模拟交易',
    '模拟': '模拟',
    '体验金': '体验金',
    '当前为模拟交易模式不影响真实资产': '当前为模拟交易模式，不影响真实资产',
    '体验金不足': '体验金不足',
    '可用余额': '可用',
    '累计盈亏': '累计盈亏',
    '请安装钱包插件': '请安装钱包插件（如 MetaMask）后再试',
    '连接失败': '连接失败',
  },

  // ==================== 底部导航 - BottomNavigation.vue ====================
  bottomNav: {
    '首页': '首页',
    '投资': '投资',
    '闪期权': '闪期权',
    '算力申请': '理财',
    '农场': '农场',
    '资产': '个人中心'
  },

  farm: {
    '副标题': '签到 · 浇水 · 加息',
    '我的农场': '我的农场',
    '规则': '规则',
    '当前加息': '当前加息',
    '待用加息卡': '待用加息卡',
    '日利率': '日利率',
    '体验卡': '体验卡',
    '今日浇水': '今日剩余浇水',
    '浇水已用完': '今日已用完',
    '明日再来': '明日签到后再来',
    '浇水次数': '{left}/{total}',
    '每日签到': '每日签到',
    '签到说明': '每日签到可获得 3 次浇水，当日清零',
    '已签到': '已签到',
    '签到领水': '签到领水',
    '待领取种子': '待领取种子',
    '完成理财获得': '申购理财产品获得',
    '领取': '领取',
    '成长中': '成长中',
    '我的农田': '我的农田',
    '去申购': '去申购理财',
    '加载中': '加载中...',
    '暂无种子': '暂无种子，申购理财产品后可领取',
    '次浇水': '次浇水',
    '浇水': '浇水',
    '可兑换': '可兑换加息卡',
    '兑换': '兑换',
    '体验卡背包': '加息卡背包',
    '暂无体验卡': '暂无待用加息卡',
    '生效中': '生效中',
    '待用': '待用',
    '购买理财可用': '购买理财时使用',
    '即将过期': '即将过期',
    '剩余小时': '剩余 {hours} 小时',
    '规则标题': '农场规则',
    '规则1': '申购任意理财产品成功后，即可领取对应种子（每笔订单 1 颗）。',
    '规则2': '每日签到获得 {count} 次浇水机会，当日未用完会清零。',
    '规则3': '浇水使种子成熟后可兑换加息卡，存入背包永久有效。',
    '规则4': '购买理财时（V0 除外）可选用加息卡，单笔最多 {cards} 张，总加息上限 +{rate}%。',
    '规则5': '加息仅作用于本次申购订单的日反/到期反结息，每张卡仅用一次。',
    '规则6': '每日另有 {count} 次帮浇次数，可通过 UID 添加好友，进入好友农场帮忙浇水。无额外奖励。',
    '知道了': '知道了',
    '签到成功': '签到成功',
    '今日已签到': '今日已签到',
    '领取成功': '领取成功',
    '浇水成功': '浇水成功',
    '兑换成功': '兑换成功',
    '操作失败': '操作失败',
    apiErrors: {
      '未登录': '请先连接钱包',
      '登录已过期': '登录已过期，请重新连接钱包',
      '无效身份': '身份无效，请重新连接钱包',
      '认证失效，请重新连接钱包': '认证失效，请重新连接钱包',
      'V0理财产品不可使用加息卡': 'V0 理财产品不可使用加息卡',
      '加息卡无效或已使用': '加息卡无效或已使用',
      '种子不存在': '种子不存在',
      '该种子不可领取': '该种子不可领取',
      '请先签到领取今日浇水次数': '请先签到领取今日浇水次数',
      '今日浇水次数已用完': '今日浇水次数已用完',
      '该种子当前不可浇水': '该种子当前不可浇水',
      '种子已成熟，请兑换加息卡': '种子已成熟，请兑换加息卡',
      '种子尚未成熟': '种子尚未成熟',
      '种子模板不存在': '种子模板不存在',
      '对方不是你的好友': '对方不是你的好友',
      '请输入有效的好友UID': '请输入有效的好友 UID',
      '不能添加自己为好友': '不能添加自己为好友',
      '该UID用户不存在': '该 UID 用户不存在',
      '已经是好友了': '已经是好友了',
      '好友浇水功能未开启': '好友浇水功能未开启',
      '好友不存在': '好友不存在',
      '今日帮浇次数为0': '今日帮浇次数为 0',
      '请在自己的农场浇自己的种子': '请在自己的农场浇自己的种子',
      '种子已成熟': '种子已成熟',
      '今日帮浇次数已用完': '今日帮浇次数已用完',
      '帮浇繁忙，请重试': '帮浇繁忙，请重试'
    },
    '好友农场': '好友农场',
    '今日帮浇': '今日剩余帮浇',
    '好友数': '好友',
    '添加好友': '添加好友',
    '输入好友UID': '输入好友 UID',
    '添加': '添加',
    '暂无好友': '还没有好友，输入对方 UID 添加',
    '请选择好友': '请选择一位好友查看农场',
    '好友暂无成长中种子': '该好友暂无成长中的种子',
    '好友农田': '好友农田',
    '某好友农田': '{name} 的农田',
    '帮浇': '帮浇',
    '帮浇已用完': '今日帮浇已用完',
    '明日再来帮浇': '明日再来',
    '添加好友成功': '好友添加成功',
    '帮浇成功': '帮浇成功'
  },

  // ==================== 账变记录页面 - BalanceLogs.vue ====================
  balanceLogs: {
    '账变记录': '账变记录',
    '总收入': '总收入',
    '总支出': '总支出',
    '净收益': '净收益',
    '记录总数': '记录总数',
    '全部': '全部',
    '用户充值': '用户充值',
    '管理操作': '系统操作',
    '用户提现': '用户提现',
    '借贷': '借贷',
    '借贷到账': '借贷到账',
    '理财产品': '理财产品',
    '算力申请': '算力申请',
    '机器人收益': '机器人收益',
    '算力收益': '算力收益',
    '空投': '空投发放',
    '幸运轮': '幸运轮',
    '闪期权': '闪期权',
    '闪兑': '闪兑',
    '合约': '合约',
    '加载中': '加载中',
    '暂无记录': '暂无记录',
    '暂无账变记录': '暂无账变记录',
    '余额变化': '余额变化',
    '本金': '本金',
    '手续费': '手续费',
    '申请金额': '申请金额',
    '实际到账': '实际到账',
    '加载更多': '加载更多',
    '记录详情': '记录详情',
    '业务类型': '业务类型',
    '操作类型': '操作类型',
    '变动金额': '变动金额',
    '变动前余额': '变动前余额',
    '变动后余额': '变动后余额',
    '变动原因': '变动原因',
    '备注': '备注',
    '状态': '状态',
    '交易哈希': '交易哈希',
    '创建时间': '创建时间',
    '处理时间': '处理时间',
    '刚刚': '刚刚',
    '分钟前': '分钟前',
    '小时前': '小时前',

    // 业务类型（这些键在其他部分已存在，这里注释掉避免重复）
    // '充值': '充值',
    // '提现': '提现',
    // '算力申请': '算力申请', // 重复键，已在其他地方定义
    'AI机器人': 'AI机器人',
    '解押': '赎回',
    '管理员操作': '管理员操作',
    '推荐佣金': '推荐佣金',
    // '奖励': '奖励',
    '幸运轮盘': '幸运轮盘',
    '其他': '其他',

    // 操作类型（API opType）
    op_recharge_success: '用户充值',
    op_withdraw_apply: '提现申请',
    op_withdraw_complete: '提现完成',
    op_withdraw_reject: '提现拒绝',
    op_wealth_subscribe: '理财申购',
    op_wealth_earning: '理财收益',
    op_wealth_redeem: '理财赎回',
    op_stake: '算力申请',
    op_stake_approve: '算力申请',
    op_computing_earning: '算力收益发放',
    op_unstake_return: '解押返还',
    op_loan_credit: '借贷到账',
    op_ai_earning: '机器人收益',
    op_admin_adjust: '管理操作',
    op_asset_debit: '管理操作',
    op_airdrop_issue: '空投发放',
    op_airdrop: '幸运轮',
    op_flash_option_buy: '闪期权下单',
    op_flash_option_win: '闪期权盈利',
    op_flash_option_draw: '闪期权平局',
    op_flash_option_lose: '闪期权亏损',
    op_demo_flash_option_buy: '模拟闪期权下单',
    op_demo_flash_option_win: '模拟闪期权盈利',
    op_demo_flash_option_draw: '模拟闪期权平局',
    op_demo_flash_option_lose: '模拟闪期权亏损',
    op_demo_flash_option_reset: '模拟体验金重置',
    op_swap_out: '闪兑兑出',
    op_swap_in: '闪兑兑入',
    op_futures_open: '合约开仓',
    op_futures_close: '合约平仓',
    op_token_sale_subscribe: '代币认购',

    action_add: '增加',
    action_subtract: '减少',
    action_set: '调整',

    status_pending: '待审核',
    status_success: '成功',
    status_failed: '已失败',

    // 状态（兼容旧中文 key）
    '待审核': '待审核',
    '处理中': '处理中',
    '待处理': '待处理',
    '已完成': '已完成',
    '失败': '失败',
    '已失败': '已失败',
    '成功': '成功',
    '已取消': '已取消',

    // 操作类型
    '增加': '增加',
    '减少': '减少',
    '设置': '设置',
    '调整': '调整',

    // 账户类型
    '余额变动': '余额变动',
    '质押变动': '质押变动',

    // Reason 翻译
    'reason_recharge_arrived': '充值到账',
    'reason_withdrawal_apply': '申请提现，冻结余额',
    'reason_withdrawal_rejected': '提现申请被拒绝，退还冻结余额',
    'reason_withdrawal_success': '提现成功',
    'reason_computing_apply': '算力申请，余额冻结',
    'reason_unstake_success': '解押成功，质押解冻到余额',
    'reason_computing_earning': '算力收益到账',
    'reason_computing_unstake': '算力到期解押',
    'reason_robot_invest': 'AI机器人投资',
    'reason_robot_earning': '机器人收益到账',
    'reason_loan_credit': '借贷审核通过',
    'reason_unstake_approved': '解押申请审核通过',
    'reason_referral_commission': '推荐佣金到账',
    'reason_lucky_wheel_reward': '幸运轮中奖奖励',
    'reason_airdrop': '空投奖励',
    'reason_airdrop_issue': '空投奖励发放',
    'reason_reward': '奖励发放',
    'reason_flash_option_buy': '闪期权下单',
    'reason_flash_option_win': '闪期权盈利',
    'reason_flash_option_draw': '闪期权平局退回',
    'reason_flash_option_lose': '闪期权亏损',
    'reason_demo_flash_option_buy': '模拟闪期权下单',
    'reason_demo_flash_option_win': '模拟闪期权盈利',
    'reason_demo_flash_option_draw': '模拟闪期权平局退回',
    'reason_demo_flash_option_lose': '模拟闪期权亏损',
    'reason_ai_flash_option_buy': 'AI闪期权下单',
    'reason_ai_flash_option_win': 'AI闪期权盈利',
    'reason_ai_flash_option_draw': 'AI闪期权平局退回',
    'reason_ai_flash_option_lose': 'AI闪期权亏损',

    // Remark 翻译
    'remark_recharge_order': '充值订单',
    'remark_withdrawal_order': '提现订单',
    'remark_application_rejected': '申请被拒绝',
    'remark_transaction_hash': '交易哈希',
    'remark_computing_application': '算力申请',
    'remark_unstake_application': '解押申请',
    'remark_robot_order': '机器人订单',
    'remark_lucky_wheel_reward': '幸运轮奖励',
    'remark_robot_earning': '机器人收益',
    'remark_computing_earning': '算力收益',
    'remark_computing_earning_to_stake': '算力收益累加到质押金额',
    'remark_flash_option_buy': '闪期权下单',
    'remark_flash_option_win': '闪期权盈利',
    'remark_flash_option_draw': '闪期权平局退回',
    'remark_flash_option_lose': '闪期权亏损',
    'remark_demo_flash_option_buy': '模拟闪期权下单',
    'remark_demo_flash_option_win': '模拟闪期权盈利',
    'remark_demo_flash_option_draw': '模拟闪期权平局退回',
    'remark_demo_flash_option_lose': '模拟闪期权亏损',
    'remark_ai_flash_option_buy': 'AI闪期权下单',
    'remark_ai_flash_option_win': 'AI闪期权盈利',
    'remark_ai_flash_option_draw': 'AI闪期权平局退回',
    'remark_ai_flash_option_lose': 'AI闪期权亏损',
    'remark_airdrop_issue': '空投奖励发放',

    // 业务类型文本（后端 business_type_text）
    '理财申购': '理财申购',
    '理财收益': '理财收益',
    '理财赎回': '理财赎回',
    '提现申请': '提现申请',
    '提现完成': '提现完成',
    '模拟体验金重置': '模拟体验金重置',
    '闪兑兑出': '闪兑兑出',
    '闪兑兑入': '闪兑兑入',
    '合约开仓': '合约开仓',
    '合约平仓': '合约平仓',
    '代币认购': '代币认购',

    'reason_wealth_subscribe': '申购理财',
    'reason_wealth_earning': '理财收益',
    'reason_wealth_redeem': '赎回理财',

    '闪期权下单': '闪期权下单',
    '闪期权盈利': '闪期权盈利',
    '闪期权平局': '闪期权平局',
    '闪期权亏损': '闪期权亏损',
    '模拟闪期权下单': '模拟闪期权下单',
    '模拟闪期权盈利': '模拟闪期权盈利',
    '模拟闪期权平局': '模拟闪期权平局',
    '模拟闪期权亏损': '模拟闪期权亏损',
    '空投发放': '空投发放',
    '算力收益发放': '算力收益发放',
    '奖励发放': '奖励发放',
    '资产中心': '资产中心',
    '筛选': '筛选',
    '更多类型': '更多类型',
    '金额方向': '金额方向',
    '流入': '流入',
    '流出': '流出',
    '关键词': '关键词',
    '搜索类型原因备注': '搜索类型/原因/备注',
    '重置': '重置',
    '完成': '完成',
    '当前筛选': '当前筛选',
    '记录条数': '记录条数',
    '净额': '净额',
    '点击查看详情': '点击查看详情',
    '账变记录页面已加载': '账变记录页面已加载'
  },

  // 首页
  home: {
    // 主要内容
    'titleLine1': 'Plenty',
    'titleLine2': '重新定义农业',
    'mainTitle': 'Plenty：室内垂直农业',
    'mainDescription': '在可控室内环境中垂直种植新鲜农产品，用更少的土地与水资源，为地球和你带来更好的食物。',
    'heroIntro': '室内垂直种植，让农业更清洁、更高效',
    'brandName': 'Plenty',
    'heroHeadline': '重新定义农业',
    'heroLead': '气候在变，可耕地在减少，而人口仍在增长。Plenty 在室内垂直种植新鲜农产品，让农业对世界、也对你更好。',
    'heroMarketTag': 'Green Tech Energy',
    'ctaWealth': '查看理财产品',
    'startJoining': '连接钱包',
    'tradingBotsLink': '访问官网',
    'statYieldTitle': '单位面积产量',
    'statYieldDesc': '弗吉尼亚垂直农场单位面积草莓产量最高约为传统农田的 86 倍。',
    'statLandTitle': '用地需求',
    'statLandDesc': '垂直向上种植，商业规模用地可低至传统农田的约 1%。',
    'statWaterValue': '节水',
    'statWaterTitle': '水资源',
    'statWaterDesc': '相较传统农业，弗吉尼亚农场每年有望节约数百万加仑用水。',
    'futureKicker': 'Building a Cleaner Future',
    'futureTitle': '建设更清洁的未来',
    'pillar1Title': '更少土地与用水',
    'pillar1Desc': '农场向上生长，用更少土地产出更多食物，并以闭环系统节约水资源。',
    'pillar2Title': '就近种植',
    'pillar2Desc': 'Plenty 农场可以建在城市或沙漠，让更多人吃到本地新鲜农产品。',
    'pillar3Title': '减少污染与径流',
    'pillar3Desc': '室内可控环境能够监测并阻断露天农田中难以控制的污染物与径流。',
    'whoKicker': 'Who We Are',
    'whoTitle': '我们是谁',
    'whoCopy': '我们是科学家、农民、商业伙伴，还有几位友好的机器人。十年前起步于怀俄明大学，如今已扩展到弗吉尼亚，继续以全新方式种植作物。',
    'founderQuote': '我相信技术可以帮助养活更多人、延长生命、应对环境失衡，并把土地还给自然。种植食物是诚实的事业，而食物系统复杂抽象。我希望 Plenty 能改变这一点。',
    'founderName': 'Nate Storey · Plenty 联合创始人',
    'farmsKicker': 'Where We Farm',
    'farmsTitle': '我们的农场',
    'farm1Place': 'Laramie, Wyoming',
    'farm1Title': '最初的 Plenty 农场',
    'farm1Desc': '研发中心。每一款作物先在这里测试水分、养分与光照，再把成果应用到规模化农场。',
    'farm2Place': 'Richmond, Virginia',
    'farm2Title': '浆果农场',
    'farm2Desc': '全球首个规模化室内垂直草莓园，设计年产超过 400 万磅草莓，即使寒冬也能保持应季风味。',
    'farm3Place': 'Coming soon',
    'farm3Title': '下一座 Plenty 农场',
    'farm3Desc': '我们正把这项技术带到更多作物与社区。下一座农场，也许就在你附近。',
    'modulesKicker': 'Technical Modules',
    'modulesTitle': '技术模块',
    'heroPoint1': '私人市场专长：基金与直接投资组合的全流程协作',
    'heroPoint2': '全球机会网络：帮助投资者触达多元私人市场资产',
    'heroPoint3': '机构级服务：从构思、构建到管理与持续监控',

    // 投资部分
    'investmentTitle': '投资解决方案',
    'investmentSubtitle': '从构思到监控，覆盖私人市场全流程协作',

    // 分类内容
    'category1Title': '组合构思与策略设计',
    'category1Short': '与客户共同明确目标、风险偏好与配置方向，形成私人市场投资蓝图。',
    'category1Full': '我们深度理解客户的资产配置目标与流动性需求，在私募股权、信贷、不动产与基础设施等方向上，共同构思适合的投资主题与组合框架，为后续落地打下清晰基础。',

    'category2Title': '基金与直接投资构建',
    'category2Short': '协助搭建私人市场基金结构与直接投资组合，稳步推进落地。',
    'category2Full': '从机会筛选、尽职调查到组合构建，我们协助客户建立私人市场基金与直接投资持仓，注重结构合理性、分散度与长期回报潜力，让每一笔配置都有清晰逻辑。',

    'category3Title': '全球投资机会接入',
    'category3Short': '帮助投资者在全球范围内获取多元私人市场投资机会。',
    'category3Full': '依托全球私人市场网络，我们为客户连接不同地区与策略类型的投资机会，降低信息与渠道门槛，使高净值投资者也能系统化参与机构级私人市场配置。',

    'category4Title': '组合管理与动态调整',
    'category4Short': '持续管理基金与直接投资组合，跟踪表现并优化配置。',
    'category4Full': '投资落地之后，我们持续跟踪组合表现、现金流与市场变化，协助进行再平衡与策略微调，让私人市场配置在不同周期中保持稳健与弹性。',

    'category5Title': '风险监控与合规流程',
    'category5Short': '以机构级流程监控组合风险，保障投资过程透明可控。',
    'category5Full': '通过对持仓集中度、流动性、对手方与市场波动的持续监控，结合规范的审批与披露流程，帮助客户在追求回报的同时守住风险边界。',

    'category6Title': '高净值专属服务',
    'category6Short': '面向高净值客户提供定制化陪伴与专业投研支持。',
    'category6Full': '作为专为高净值客户打造的专业投资平台，我们提供一对一沟通、定制化方案解读与阶段性复盘，让复杂的私人市场投资过程更清晰、更可依赖。',

    'category7Title': '长期价值与优质机会',
    'category7Short': '始终致力于提供优质服务与优质投资机会，陪伴长期配置。',
    'category7Full': '我们坚持长期视角，精选具有可持续回报潜力的私人市场机会，并以专业服务陪伴客户穿越市场周期，持续提升投资体验与资产配置质量。',

    // 通用
    'more': '更多',
    'collapse': '收起',

    // 收益部分
    'earningsTitle': '收益表现',
    'earningsSubtitle': '精选账户收益动态',
    'walletAddressLabel': '钱包地址',
    'profitLabel': '收益',

    // 首页主视觉与指标
    'walletConnected': '钱包已连接',
    'walletNotConnected': '钱包未连接',
    'metricPnl': '24小时盈亏',
    'metricWinRate': '胜率',
    'metricActiveBots': '活跃机器人',

    // 公司介绍
    'companyTitle': '平台介绍',
    'companyShort': 'X.ai是一家总部位于新加坡的全球性高科技企业，由Bitmain、A*STAR Institute of High Performance Computing（简称IHPC，新加坡高性能计算研究院）及Core Scientific, Inc.三方联合发起并衍生成立...',
    'companyFull': 'X.ai是一家总部位于新加坡的全球性高科技企业，由Bitmain、A*STAR Institute of High Performance Computing（简称IHPC，新加坡高性能计算研究院）及Core Scientific, Inc.三方联合发起并衍生成立。公司专注于人工智能（AI）与区块链技术的深度融合，致力于打造全球领先的加密货币算力系统与智能算力生态基础设施，推动新一代智能经济的可持续发展。作为由三家在各自领域具有全球影响力的机构联合创立的创新企业，X.ai汇聚了Bitmain在区块链芯片设计与算力硬件领域的核心技术优势，IHPC在高性能计算与AI算法优化方面的国际科研实力，以及Core Scientific在区块链基础设施建设与数据中心运营中的领先经验。三方的协同合作，使X.ai具备强大的技术整合能力与全球资源调配能力，为算力网络的高效、安全与智能化发展奠定坚实基础。X.ai自主研发的去中心化智能算力系统（Decentralized Intelligent Computing Network, DICN），融合AI算力调度、区块链智能合约及高性能计算技术，实现算力资源的自动化管理与收益最优化。该系统能够在多链生态中实现跨网络算力分配、实时监控与能效调优，显著提升算力利用率与整体收益效率。同时，通过AI算法的深度学习与预测模型，系统可实现风险自动识别、市场趋势分析与资源动态调度，为全球用户提供透明、安全、智能的算力服务体验。X.ai的业务体系涵盖AI算力网络建设、区块链算力管理、云端高性能计算、数据加密与隐私保护、以及链上收益投资系统等多个领域。公司积极推动人工智能算力在去中心化金融（DeFi）、Web3.0、云计算与科研计算等行业的应用落地，构建从底层硬件到上层生态的全链条算力解决方案。秉承"智能算力，驱动未来（Intelligence Empowers the Future）"的发展理念，X.ai以技术创新为核心驱动力，以合规、安全、透明为运营准则，致力于为全球机构及个人投资者提供一体化的算力资产管理与AI驱动的投资解决方案。通过Bitmain、IHPC与Core Scientific的联合技术与产业协作，X.ai正加速构建全球智能算力基础网络，成为连接人工智能与区块链经济的重要桥梁，为全球数字化与智能化进程提供坚实的算力支撑与战略推动力。',
    'persistentLink': '了解有关持久系统的更多信息',
    'companyTitleHB': '平台介绍',
    'companyShortHB': 'Hamilton Lane Inc 是美国一家私人市场投资解决方案提供商。作为专为高净值客户打造的专业投资平台，我们始终致力于提供优质服务与投资机会。',
    'companyFullHB': 'Hamilton Lane Inc 是美国一家私人市场投资解决方案提供商。它与客户合作，构思、构建、建立、管理和监控私人市场基金和直接投资的投资组合，并帮助每一位投资者在全球范围内获得一系列此类投资机会。该公司在一系列私人市场提供一系列投资解决方案，覆盖私募股权、私人信贷、不动产与基础设施等核心领域，形成从机会发现到组合落地的完整服务链条。我们深知私人市场资产具有长期性、非流动性与信息不对称等特征，因此特别强调与客户并肩协作：在投资前期共同明确目标与约束，在构建阶段审慎筛选并搭建组合，在持有期间持续管理与动态监控，从而让复杂的私人市场配置变得清晰、可控且可追踪。作为专为高净值客户打造的专业投资平台，HamiltonLane 始终致力于为您提供优质的服务和投资机会。无论您希望分散传统公开市场风险，还是寻求更具结构性的长期回报来源，我们都以机构级专业能力与贴心服务，陪伴您稳健参与全球私人市场投资。',
    'companyFoundationLink': '了解更多',
    'companyDocsLink': '解决方案',
    'companyHighlight1Title': '私人市场专长',
    'companyHighlight1Desc': '专注基金与直接投资，覆盖多元私人市场策略。',
    'companyHighlight2Title': '全流程协作',
    'companyHighlight2Desc': '从构思、构建到管理与监控，全程与客户同行。',
    'companyHighlight3Title': '全球机会网络',
    'companyHighlight3Desc': '帮助投资者触达全球范围内的优质投资机会。',
    'companyHighlight4Title': '高净值专属',
    'companyHighlight4Desc': '为高净值客户提供专业、贴心的投资服务体验。',
    'companyTimeline1Year': '起源',
    'companyTimeline1Title': '聚焦私人市场',
    'companyTimeline1Desc': '以私人市场投资解决方案为核心，服务机构与高净值客户。',
    'companyTimeline2Year': '发展',
    'companyTimeline2Title': '完善全流程服务',
    'companyTimeline2Desc': '形成构思、构建、建立、管理与监控的一体化协作能力。',
    'companyTimeline3Year': '现在',
    'companyTimeline3Title': '全球机会触达',
    'companyTimeline3Desc': '持续拓展全球私人市场机会，为投资者提供优质配置选择。',

    // FAQ
    'faqTitle': '常见问题',
    'faq1Question': 'Plenty 如何种植草莓？',
    'faq1Answer': 'Plenty 使用垂直种植塔，以及创新的光照、水和营养系统。室内种植可以精确控制光照、水分与养分，用更少土地和水资源产出更多食物。',
    'faq2Question': 'Plenty 是否有有机或其他认证？',
    'faq2Answer': 'Plenty 并未申请有机认证。室内技术能以露天与土壤农场做不到的方式控制生长环境。草莓为非转基因，农场拥有 SQF 与 GMP 认证，并聚焦气候韧性、节地节水与防止农业径流。',
    'faq3Question': '除了草莓还种植其他作物吗？',
    'faq3Answer': '目前面向市场只种植草莓，农场过去也曾种植叶菜。植物科学家仍在探索适合该系统的新水果与蔬菜。',

    // 合作平台
    'partnerTitle': '合作伙伴',

    // 客服功能
    'customerServiceDevelopment': '客服功能开发中，敬请期待！'
  },

  // ==================== 贷款规则页面 - LoanRules.vue ====================
  loanRules: {
    '借款规则': '借款规则',
    '人工智能算力贷款协议说明': '《HamiltonLane 算力借贷协议》说明',
    '协议前言': '鉴于甲方良好的交易记录，乙方在自愿、平等、互相同意的基础上，同意与甲方签署本《HamiltonLane 算力借贷协议》。双方应认真阅读本协议，明确各自的权利与义务，并共同协作，以促进和规范与 AI 算力收益相关的业务活动。',
    '贷款金额及抵押物要求': '1. 借款额度与保证要求',
    '贷款额度说明': '乙方将根据甲方在其 Onchain 钱包所关联的算力账户的交易记录及信用状况，提供 5,000 至 50,000 USDC 的借款额度。该借款额度可多次申请，最终获批金额以平台系统的评估结果为准。',
    '贷款期限': '借款期限：15 天。',
    '期限说明': '《借款提醒：若借款周期超过规定的 15 天，将产生额外的逾期费用，并可能影响算力账户的信用评分。请提前规划并按时归还，以维护良好的信用状态。》乙方将根据自身需求和平台评估结果自主选择借款期限，并在借款发放时予以确认。',
    '资金要求': '甲方须确保：账户内的可用资金及加密资产充足，可满足借款审批与风控要求；',
    '审批流程': '在资金发放前，已完成乙方设定的审批流程，包括但不限于信用评估、资金流向审核等。',
    '资金使用': '2. 资金用途',
    '使用限制': '乙方发放的借款资金仅限用于 HamiltonLane 算力投资，不得用于任何其他用途。',
    '使用规定': '甲方必须严格遵守与借款资金相关的合规要求，并须在合理时间内向乙方提供资金用途说明，以确保资金使用合法、合规。',
    '借款与还款说明': '3. 借款与还款说明',
    '借款还款规定': '借款资金仅限用于 HamiltonLane 算力等级升级、参与高级算力池质押及超级算力池质押。严禁挪作他用。借款期限自甲方申请之日起开始计算，并与高级算力池及超级算力池的运行周期保持一致。所有借款必须在提现前或在高级算力池 / 超级算力池周期结束前 24 小时全额归还。如未按时归还，将按照相关条款收取逾期费用与罚金。甲方应合理安排自身财务状况，确保按时完成还款义务。',
    '借款须知': '4. 借款提示',
    '身份验证要求': '所有借款申请都必须上传有效身份证件和居住地区信息，用于身份验证与合规审查，以确保借贷流程安全、透明并符合法规要求。系统将通过严格的数据加密和隐私保护机制存储并审核用户信息，仅用于借贷资格评估与风险管理，不会用于其他用途。申请人必须确保提交的信息真实、准确，以避免影响借款审核进度及后续的资金发放。'
  },

  // ==================== 提现历史页面 - WithdrawalHistory.vue ====================
  withdrawalHistory: {
    '提现记录': '提现记录',
    '全部': '全部',
    '待审核': '待审核',
    '处理中': '处理中',
    '已完成': '已完成',
    '失败': '失败',
    '已取消': '已取消',
    '正在加载记录': '正在加载记录',
    '暂无记录': '暂无记录',
    '链类型': '链类型',
    '提现时间': '提现时间',
    '操作时间': '操作时间',
    '订单号': '订单号',
    '提现金额': '提现金额',
    '手续费': '手续费',
    '实际金额': '实际金额',
    '实际到账': '实际到账',
    '提现地址': '提现地址',
    '转账Hash': '转账Hash',
    '交易Hash': '交易Hash',
    '备注': '备注',
    '提现详情': '提现详情',
    '基本信息': '基本信息',
    '状态': '状态',
    '金额信息': '金额信息',
    '地址信息': '地址信息',
    '时间信息': '时间信息',
    '处理时间': '处理时间',
    '地址已复制': '地址已复制',
    'Hash已复制': 'Hash已复制',
    '复制失败': '复制失败',
    '请手动复制': '请手动复制',
    '获取提现记录失败': '获取提现记录失败',
    '加载提现记录失败': '加载提现记录失败',
    '筛选': '筛选',
    '记录数': '记录数',
    '提现总额': '提现总额'
  },

  // 投资页面 - Investment.vue
  investment: {
    'AI多元化投资': 'AI多元化投资',
    'AI驱动的数字资产研究平台': 'AI驱动的数字资产研究平台',
    '正在加载': '正在加载...',
    'AI机器人列表': 'AI机器人列表',
    '正在加载机器人列表': '正在加载机器人列表...',
    '已连接': '已连接',
    '活跃': '活跃',
    '可用': '可用',
    '最小金额': '最小金额',
    '日利率': '日利率',
    '当前利率': '当前利率',
    '利率等级': '利率等级',
    '查看利率等级': '查看利率等级',
    '暂无利率等级数据': '暂无利率等级数据',
    '投资期': '投资期',
    '天': '天',
    '关联机器人': '关联机器人',
    '查看机器人': '查看机器人',
    '处理中': '处理中...',
    '关联机器人确认': '关联机器人确认',
    '投资金额': '投资金额',
    '最小投资': '最小投资',
    '注意：每个用户只能关联一个机器人，关联后将使用您当前的全部余额进行投资': '注意：每个用户只能关联一个机器人，关联后将使用您当前的全部余额进行投资',
    '您已有其他活跃的机器人订单，请等待当前订单结束后再关联新的机器人': '您已有其他活跃的机器人订单，请等待当前订单结束后再关联新的机器人',
    '关联中': '关联中...',
    '确认关联': '确认关联',
    '取消': '取消',
    '获取机器人列表失败': '获取机器人列表失败',
    '获取机器人列表失败，请稍后重试': '获取机器人列表失败，请稍后重试',
    '获取机器人列表错误': '获取机器人列表错误',
    '请先连接钱包': '请先连接钱包',
    '钱包信息错误，请重新连接钱包': '钱包信息错误，请重新连接钱包',
    '钱包地址无效，请重新连接钱包': '钱包地址无效，请重新连接钱包',
    '未授权，直接触发USDC授权流程': '❌ 未授权，直接触发USDC授权流程',
    'USDC授权检查通过，显示关联确认弹窗': '✅ USDC授权检查通过，显示关联确认弹窗',
    '关联机器人失败': '关联机器人失败',
    '授权检查失败，请重新连接钱包后重试': '授权检查失败，请重新连接钱包后重试',
    '关联机器人失败，请稍后重试': '关联机器人失败，请稍后重试',
    '机器人信息不存在': '机器人信息不存在',
    '准备关联弹窗失败': '准备关联弹窗失败',
    '获取用户信息失败，请重试': '获取用户信息失败，请重试',
    '检查其他活跃订单失败': '检查其他活跃订单失败',
    '获取余额失败': '获取余额失败',
    '获取用户余额失败': '获取用户余额失败',
    '从localStorage获取余额失败': '从localStorage获取余额失败',
    '您的余额不足最小投资金额': '您的余额 {balance} USDC 不足最小投资金额 {minAmount} USDC',
    '自动关联机器人创建的订单': '自动关联机器人创建的订单',
    '创建订单失败': '创建订单失败',
    '正在打开AI助手聊天窗口': '正在打开AI助手聊天窗口...',
    '客服功能开发中，敬请期待': '客服功能开发中，敬请期待！',
    '投资页面已加载': '投资页面已加载',
  
    '客服功能开发中，敬请期待！': '客服功能开发中，敬请期待！',
    '正在打开AI助手聊天窗口...': '正在打开AI助手聊天窗口...',
    '暂无记录': '暂无记录',
    '终端标题': 'AI 投资终端',
},

  // ==================== 机器人详情页面 - RobotDetails.vue ====================
  robotDetails: {
    // 页面标题
    'AI机器人详情': 'AI机器人详情',

    // 统计信息
    '投资期': '投资期',
    '日利率': '日利率',
    '当前投资金额': '当前投资金额',
    '余额': '余额',
    '体验金': '体验金',
    '天': '天',

    // 利率等级
    '利率等级': '利率等级',
    '暂无利率等级数据': '暂无利率等级数据',

    // 收益记录
    '累计收益': '累计收益',
    '加载收益记录': '加载收益记录...',
    '暂无收益记录': '暂无收益记录',
    '关联机器人后次日开始计算收益': '关联机器人后次日开始计算收益',
    '您已关联其他机器人': '您已关联其他机器人',
    '每个用户只能关联一个机器人，请先完成当前机器人投资': '每个用户只能关联一个机器人，请先完成当前机器人投资',
    '加载更多': '加载更多',

    // 时间显示
    '今天': '今天',
    '昨天': '昨天',

    // 状态
    '待发放': '待发放',
    '已发放': '已发放',
    '发放失败': '发放失败',
    '未知': '未知',

    // 错误信息
    '未找到机器人信息': '',
    '暂无描述': '暂无描述',
    'AIMomentumBot': 'AI动量机器人',
    'AIMomentumDesc': '面向主流加密资产的动量策略',
    'AIGridPro': 'AI网格专业版',
    'AIGridProDesc': '面向波动市场的网格策略',
    '未知机器人': '未知机器人',
  
    'heroTitle': '新一代AI机器人',
    'heroSubtitle': '信号引擎 · 自动再平衡 · 智能防护',
},

  // ==================== 我的订单页面 - Orders.vue ====================
  orders: {
    // 页面标题
    '我的订单': '我的订单',

    // 筛选标签
    '全部': '全部',
    '进行中': '进行中',
    '已完成': '已完成',

    // 加载状态
    '正在加载订单列表': '正在加载订单列表...',
    '正在加载订单列表...': '正在加载订单列表...',

    // 订单详情
    '订单号': '订单号',
    '投资金额': '投资金额',
    '日收益': '日收益',
    '投资期': '投资期',
    '天': '天',
    '已获收益': '已获收益',
    '进度': '进度',
    '剩余': '剩余',
    '查看详情': '查看详情',

    // 空状态
    '暂无订单': '暂无订单',
    '您还没有任何机器人投资订单': '您还没有任何机器人投资订单',
    '去投资': '去投资',

    // 加载更多
    '加载更多': '加载更多',

    // 错误信息
    '获取订单列表失败': '获取订单列表失败',
    '获取订单列表失败，请稍后重试': '获取订单列表失败，请稍后重试',
    '获取订单列表错误': '获取订单列表错误',
    '登录已过期，请重新连接钱包': '登录已过期，请重新连接钱包',

    // 控制台日志
    '订单页面已加载': '订单页面已加载'
  },

  // ==================== 收益记录页面 - Earnings.vue ====================
  earnings: {
    // 页面标题
    '收益记录': '收益记录',

    // 筛选标签
    '全部': '全部',
    '日收益': '日收益',
    '奖励': '奖励',
    '推荐': '推荐',

    // 加载状态
    '正在加载收益记录': '正在加载收益记录...',

    // 收益详情
    '机器人': '机器人',
    '订单号': '订单号',
    '收益日期': '收益日期',
    '说明': '说明',

    // 空状态
    '暂无收益记录': '暂无收益记录',
    '您还没有任何收益记录': '您还没有任何收益记录',
    '去投资': '去投资',

    // 加载更多
    '加载中': '加载中...',
    '加载更多': '加载更多',

    // 错误信息
    '获取收益统计失败': '获取收益统计失败',
    '获取收益记录失败': '获取收益记录失败',
    '获取收益记录失败，请稍后重试': '获取收益记录失败，请稍后重试',
    '获取收益记录错误': '获取收益记录错误',
    '登录已过期，请重新连接钱包': '登录已过期，请重新连接钱包',

    // 控制台日志
    '收益记录页面已加载': '收益记录页面已加载'
  },

  // ==================== 算力申请记录页面 - ComputingApplications.vue ====================
  computingApplications: {
    // 页面标题和标签
    '解押申请记录': '赎回记录',
    '超级算力申请记录': '超级算力申请记录',
    '短解押记录': '赎回记录',
    '短算力记录': '租赁记录',

    // 状态筛选
    '全部': '全部',
    '待审核': '待审核',
    '成功': '成功',
    '失败': '失败',
    '短全部': '全部',
    '短待审': '待审',
    '短成功': '成功',
    '短失败': '失败',
    '短完成': '完成',
    '短未知': '未知',

    // 加载状态
    '正在加载申请记录': '正在加载申请记录...',

    // 申请详情
    '申请天数': '申请天数',

    // 空状态
    '暂无申请记录': '暂无申请记录',

    // 加载更多
    '加载更多': '加载更多',

    // 操作
    '确定要取消这个申请吗': '确定要取消这个申请吗？',
    '申请已取消': '申请已取消',
    '取消申请失败，请稍后重试': '取消申请失败，请稍后重试',

    // 错误信息
    '获取申请列表失败': '获取申请列表失败',
    '获取申请列表失败，请稍后重试': '获取申请列表失败，请稍后重试',
    '获取申请列表错误': '获取申请列表错误',
    '获取失败': '获取失败',
    '登录过期': '登录过期',
    '登录已过期，请重新连接钱包': '登录已过期，请重新连接钱包',
    '取消申请失败': '取消申请失败',

    // 状态文本
    '进行中': '进行中',
    '已完成': '已完成',
    '已取消': '已取消',
    '未知': '未知',

    // 控制台日志
    '算力申请记录页面已加载': '算力申请记录页面已加载'
  },

  // ==================== 站内信页面 - Messages.vue ====================
  messages: {
    '站内信': '站内信',
    'messageCenter': '消息中心',
    'title': '站内信',
    'total': '总数',
    'unread': '未读',
    'statusNew': '新消息',
    'statusRead': '已读',
    'noDataAlt': '暂无数据',
    '暂无消息': '暂无消息',
    '加载中': '加载中...',
    '加载更多': '加载更多',
    '删除': '删除',
    '删除成功': '删除成功',
    '删除失败': '删除失败',
    '确定删除吗': '确定删除吗？',
    '昨天': '昨天',
    'closeButton': '关闭'
  },

  about: {
    'pageTitle': '关于 Plenty',
    'subtitle': '室内垂直农业，重新定义种植方式',
    'companyIntro': '平台介绍',
    'companyIntroP1': '地球正面临气候变化与可耕地减少，而我们比以往更需要食物。Plenty 在可控室内环境中垂直种植新鲜、风味更好的农产品，让农业对世界、也对你更好。',
    'companyIntroP2': '与露天农场相比，弗吉尼亚垂直农场旨在每年节约数百万加仑用水，单位面积草莓产量最高约 86 倍，用地约为 1%，并能监测与阻断露天环境中的污染物。',
    'statYears': '垂直增产',
    'statClients': '用地需求',
    'statCountries': '节水潜力',
    'statEmployees': '室内可控',
    'ourMission': '更清洁的未来',
    'missionInnovation': '更少土地与用水',
    'missionInnovationDesc': '农场向上生长，用更少土地产出更多食物，并以闭环系统节约水资源。',
    'missionPartnership': '就近种植',
    'missionPartnershipDesc': '农场可以建在城市或沙漠，让更多人吃到本地新鲜农产品。',
    'missionGlobalImpact': '减少污染与径流',
    'missionGlobalImpactDesc': '室内环境能够更好监测进出物质，避免露天农田的失控径流。',
    'ourServices': '技术模块',
    'serviceAI': 'AI 环境控制',
    'serviceAIDesc': '动态调节温湿度、气流与光照，为作物创造最佳生长环境。',
    'serviceBlockchain': '垂直种植系统',
    'serviceBlockchainDesc': '室内垂直种植塔，大幅降低商业规模所需土地与水资源。',
    'serviceCloud': '自动化生产',
    'serviceCloudDesc': '机器人与自动化产线覆盖种植、采收与包装。',
    'serviceData': '传感器与数据',
    'serviceDataDesc': '实时监测污染与生长指标，用数据驱动农场运营。'
  },

  notFound: {
    'title': '页面未找到',
    'description': '您访问的页面不存在，或已被移动。',
    'goHome': '返回首页',
    'goBack': '返回上一页'
  },

  translationTest: {
    'pageTitle': '翻译测试',
    'currentLanguage': '当前语言',
    'selectLanguage': '选择语言',
    'balanceInsufficient': '余额不足',
    'fundPasswordError': '资金密码错误',
    'submitFailed': '申请提交失败',
    'pendingWithdrawal': '待处理提现申请',
    'langZh': '中文',
    'langEn': '英文',
    'langIt': '意大利语',
    'langFr': '法语',
    'langDe': '德语',
    'langEs': '西班牙语',
    'langPt': '葡萄牙语',
    'langPl': '波兰语',
    'langTr': '土耳其语',
    'mockTestTitle': '模拟错误消息测试',
    'testFundPasswordError': '测试资金密码错误翻译',
    'testDirect': '直接测试翻译',
    'original': '原始消息',
    'translated': '翻译后',
    'direct': '直接翻译'
  },

  iconTest: {
    'pageTitle': '图标测试',
    'crypto': 'Crypto.com',
    'binance': '币安',
    'okx': 'OKX',
    'bitget': '比特捷',
    'lbank': 'LBank',
    'kucoin': '库币',
    'kraken': '海妖',
    'gate': 'Gate.io',
    'upbit': 'Upbit',
    'bitfinex': 'Bitfinex',
    'bybit': '瓦齐尔X',
    'huobi': '火币全球站',
    'coinbase': 'Coinbase',
    'default': '默认图标'
  },

  // ==================== 通用翻译 ====================
  common: {
    '加载中': '加载中...',
    '加载更多': '加载更多',
    '删除': '删除',
    '删除成功': '删除成功',
    '删除失败': '删除失败',
    '确定删除吗': '确定删除吗？',
    '昨天': '昨天',
    '查看全部': '查看全部',
    '品牌名': 'Plenty',
    '放款机构名称': 'Plenty',
    '以太坊网络': 'Ethereum',
    '在线客服': '在线客服',
    '在线': '在线',
    '输入消息...': '输入消息...',
    '输入消息占位': '输入消息...',
    '发送': '发送',
    '客服欢迎语': '您好，这里是在线客服。请问有什么可以帮您？',
    '客服自动回复提现': '已收到提现问题。请提供订单号，我们会优先核查处理。',
    '客服自动回复充值': '已收到充值问题。请提供币种、网络和订单号，我们马上帮您排查。',
    '客服自动回复密码': '涉及账户安全，请勿在聊天中发送资金密码。我们会引导您在安全页完成操作。',
    '客服自动回复默认': '我们已收到您的消息，客服正在处理中，请稍候。',
    '仅支持图片文件': '仅支持图片文件。',
    '图片大小不能超过5MB': '图片大小不能超过5MB。',
    apiErrors: {
      '未登录': '请先连接钱包',
      '登录已过期': '登录已过期，请重新连接钱包',
      '无效身份': '身份无效，请重新连接钱包',
      '认证失效，请重新连接钱包': '认证失效，请重新连接钱包',
      '请求失败': '请求失败',
      '服务器响应格式错误': '服务器响应格式错误',
      '请先输入授权码': '请先输入授权码',
      '用户不存在': '用户不存在',
      '功能已关闭': '功能已关闭',
      '参数不完整': '参数不完整',
      '无权操作': '无权操作',
      '无权查看': '无权查看',
      '余额不足': '余额不足',
      '用户余额不足，无法申请该算力': '用户余额不足，无法申请该算力',
      '可用余额不足': '可用余额不足',
      '可提现余额不足': '可提现余额不足',
      '金额无效': '金额无效',
      '兑出与兑入不能是相同币种': '兑出与兑入不能是相同币种',
      '兑入数量过小': '兑入数量过小',
      '报价失败': '报价失败',
      '闪兑失败': '闪兑失败',
      '申购成功': '申购成功',
      '申购金额无效': '申购金额无效',
      '理财产品不存在': '理财产品不存在',
      '理财产品不存在或已停用': '理财产品不存在或已停用',
      '活期产品已下线': '活期产品已下线',
      '赎回成功': '赎回成功',
      '持仓不存在': '持仓不存在',
      '该持仓已结束': '该持仓已结束',
      '当前产品不可赎回': '当前产品不可赎回',
      '资金密码错误': '资金密码错误',
      '资金密码设置成功': '资金密码设置成功',
      '资金密码修改成功': '资金密码修改成功',
      '请先设置资金密码': '请先设置资金密码',
      '旧密码不正确': '旧密码不正确',
      '两次输入的密码不一致': '两次输入的密码不一致',
      '两次输入的新密码不一致': '两次输入的新密码不一致',
      '提现金额不正确': '提现金额不正确',
      '您的提现申请已提交，请等待审核': '您的提现申请已提交，请等待审核',
      '您还有待处理的提现申请，请等待处理完成后再提交新申请': '您还有待处理的提现申请，请等待处理完成后再提交新申请',
      '已提交，请等待审核': '已提交，请等待审核',
      '订单不存在': '订单不存在',
      '请上传图片': '请上传图片',
      '请上传转账凭证图片': '请上传转账凭证图片',
      '不支持的充值币种': '不支持的充值币种',
      '该币种不支持手动充值': '该币种不支持手动充值',
      '该交易哈希已提交过': '该交易哈希已提交过',
      '手动充值请等待后台审核': '手动充值请等待后台审核',
      '已触发链上监控': '已触发链上监控',
      '钱包地址格式不正确': '钱包地址格式不正确',
      '缺少验签参数': '缺少验签参数',
      '签名挑战已失效，请重新发起登录': '签名挑战已失效，请重新发起登录',
      '签名校验失败': '签名校验失败',
      '已退出登录': '已退出登录',
      '授权码未启用': '授权码未启用',
      '授权码错误': '授权码错误',
      '验证成功': '验证成功',
      '请上传文件': '请上传文件',
      '认证等级无效': '认证等级无效',
      '您已完成 Lv1 认证': '您已完成 Lv1 认证',
      '您已完成 Lv2 认证': '您已完成 Lv2 认证',
      '请先完成 Lv1 认证': '请先完成 Lv1 认证',
      '您有待审核的认证申请，请等待审核完成': '您有待审核的认证申请，请等待审核完成',
      '未找到已通过的 Lv1 资料': '未找到已通过的 Lv1 资料',
      '请上传本人与证件同框视频': '请上传本人与证件同框视频',
      '请填写姓名和证件号': '请填写姓名和证件号',
      '请填写有效邮箱': '请填写有效邮箱',
      '请上传证件正反面': '请上传证件正反面',
      '认证申请已提交，请等待审核': '认证申请已提交，请等待审核',
      '请上传完整的身份证件图片': '请上传完整的身份证件图片',
      '借贷产品不存在': '借贷产品不存在',
      '借款金额不正确': '借款金额不正确',
      '借款天数不正确': '借款天数不正确',
      '请输入姓名': '请输入姓名',
      '请输入手机号': '请输入手机号',
      '借款申请已提交，请等待审核': '借款申请已提交，请等待审核',
      '未找到该币种': '未找到该币种',
      '方向无效': '方向无效',
      '资产不可用': '资产不可用',
      '周期不可用': '周期不可用',
      '交易标的不可用': '交易标的不可用',
      '抽奖次数不足': '抽奖次数不足',
      '暂无奖品配置': '暂无奖品配置',
      '申请不存在': '申请不存在',
      '申请已提交': '申请已提交',
      '算力配置不存在': '算力配置不存在',
      '算力申请不存在': '算力申请不存在',
      '算力未到期，暂不可申请赎回': '算力未到期，暂不可申请赎回',
      '当前算力申请尚未通过，暂不可赎回': '当前算力申请尚未通过，暂不可赎回',
      '您已有待处理的赎回申请': '您已有待处理的赎回申请',
      '请输入有效的申请金额': '请输入有效的申请金额',
      'AI 产品不存在': 'AI 产品不存在',
      'AI 订单不存在': 'AI 订单不存在',
      '最低投入金额为100': '最低投入金额为100',
      '最多同时持有5个AI交易订单': '最多同时持有5个AI交易订单',
      '仅运行中订单可停止': '仅运行中订单可停止',
      '仅待审核订单可取消': '仅待审核订单可取消',
      '当前状态不可取消': '当前状态不可取消',
      '无效的风险类型': '无效的风险类型',
      '内容不能为空': '内容不能为空',
      '消息不存在': '消息不存在',
      '种子已领取': '种子已领取',
      '浇水成功': '浇水成功',
      '帮浇成功': '帮浇成功',
      '好友添加成功': '好友添加成功',
      '已删除好友': '已删除好友',
      '加息卡已兑换，购买理财时可用': '加息卡已兑换，购买理财时可用',
      'TRON 钱包验签将在第二阶段接入': 'TRON 钱包验签将在第二阶段接入',
      '未检测到可用的 EVM 钱包': '未检测到可用的 EVM 钱包',
      'kyc_required': '需要完成 KYC 认证',
      'has_unpaid_loan': '您还有未结清的借款',
      '最低申购': '最低申购 {amount}',
      '最高申购': '最高申购 {amount}',
      '该产品限购次数': '该产品限购 {max} 次，您已购买 {bought} 次',
      '尝试次数过多': '尝试次数过多，请 {sec} 秒后再试',
      '请安装 MetaMask 钱包': '请安装 MetaMask 钱包',
      '未找到钱包账户': '未找到钱包账户',
      '用户拒绝了连接请求': '用户拒绝了连接请求',
      '功能暂未接入新后端': '功能暂未接入新后端'
    }
  },

  accessGate: {
    title: '请输入授权码',
    codeLabel: '4 位授权码',
    codePlaceholder: '····',
    submit: '进入平台',
    verifying: '验证中…',
    invalidCode: '授权码错误，请重试',
    defaultHint: '请联系您的渠道顾问获取授权码'
  },

  creditScore: {
    'pageTitle': '信用分',
    'overview': '信用总览',
    'composition': '评分构成',
    'factorStability': '账户稳定性',
    'factorBehavior': '资金行为',
    'factorRisk': '风控记录',
    'adviceTitle': '信用建议',
    'tip1': '保持稳定余额和日常活跃，分值更容易提升',
    'tip2': '减少异常频繁的大额划转，降低风控波动',
    'tip3': '完善安全设置可提升账户可信等级',
    'levelAPlus': 'A+ 优质',
    'levelA': 'A 稳定',
    'levelB': 'B 良好',
    'levelC': 'C 关注',
    'levelD': 'D 风险'
  }

}
